import _slicedToArray from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _get from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/get";
import _assertThisInitialized from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _inherits from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _asyncToGenerator from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e12) { throw _e12; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e13) { didErr = true; err = _e13; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.flat.js";
import "core-js/modules/esnext.global-this.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _regeneratorRuntime from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator";
import { Buffer as t } from "buffer";
import { sendAndConfirmRawTransaction as e, PublicKey as n, Transaction as r, TransactionInstruction as i, SystemProgram as o, SYSVAR_RENT_PUBKEY as s } from "@solana/web3.js";
import * as a from "@solana/web3.js";
export { a as web3 };
import c from "bn.js";
export { default as BN } from "bn.js";
import u from "bs58";
import d from "camelcase";
import { sha256 as l } from "js-sha256";
import * as h from "@project-serum/borsh";
import * as p from "base64-js";
import * as f from "assert";
import m from "assert";
import { inflate as y } from "pako";
import g from "eventemitter3";

var w = /*#__PURE__*/function () {
  function w(t, e, n) {
    _classCallCheck(this, w);

    this.connection = t, this.wallet = e, this.opts = n;
  }

  _createClass(w, [{
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, n, r) {
        var i;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                void 0 === n && (n = []);
                void 0 === r && (r = this.opts);
                t.feePayer = this.wallet.publicKey;
                _context.next = 5;
                return this.connection.getRecentBlockhash(r.preflightCommitment);

              case 5:
                t.recentBlockhash = _context.sent.blockhash;
                _context.next = 8;
                return this.wallet.signTransaction(t);

              case 8:
                n.filter(function (t) {
                  return void 0 !== t;
                }).forEach(function (e) {
                  t.partialSign(e);
                });
                i = t.serialize();
                _context.next = 12;
                return e(this.connection, i, r);

              case 12:
                return _context.abrupt("return", _context.sent);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function send(_x, _x2, _x3) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "sendAll",
    value: function () {
      var _sendAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t, n) {
        var _this = this;

        var r, i, o, s, _t2, _r;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                void 0 === n && (n = this.opts);
                _context2.next = 3;
                return this.connection.getRecentBlockhash(n.preflightCommitment);

              case 3:
                r = _context2.sent;
                i = t.map(function (t) {
                  var e = t.tx,
                      n = t.signers;
                  return void 0 === n && (n = []), e.feePayer = _this.wallet.publicKey, e.recentBlockhash = r.blockhash, n.filter(function (t) {
                    return void 0 !== t;
                  }).forEach(function (t) {
                    e.partialSign(t);
                  }), e;
                });
                _context2.next = 7;
                return this.wallet.signAllTransactions(i);

              case 7:
                o = _context2.sent;
                s = [];
                _t2 = 0;

              case 10:
                if (!(_t2 < i.length)) {
                  _context2.next = 20;
                  break;
                }

                _r = o[_t2].serialize();
                _context2.t0 = s;
                _context2.next = 15;
                return e(this.connection, _r, n);

              case 15:
                _context2.t1 = _context2.sent;

                _context2.t0.push.call(_context2.t0, _context2.t1);

              case 17:
                _t2 += 1;
                _context2.next = 10;
                break;

              case 20:
                return _context2.abrupt("return", s);

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendAll(_x4, _x5) {
        return _sendAll.apply(this, arguments);
      }

      return sendAll;
    }()
  }, {
    key: "simulate",
    value: function () {
      var _simulate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t, e) {
        var n,
            r,
            i,
            o,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                n = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : this.opts;
                void 0 === e && (e = []);
                t.feePayer = this.wallet.publicKey;
                _context4.next = 5;
                return this.connection.getRecentBlockhash(null !== (r = n.preflightCommitment) && void 0 !== r ? r : this.opts.preflightCommitment);

              case 5:
                t.recentBlockhash = _context4.sent.blockhash;
                _context4.next = 8;
                return this.wallet.signTransaction(t);

              case 8:
                e.filter(function (t) {
                  return void 0 !== t;
                }).forEach(function (e) {
                  t.partialSign(e);
                });
                _context4.next = 11;
                return function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t, e, n) {
                    var r, i, o, s;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return t._recentBlockhash(t._disableBlockhashCaching);

                          case 2:
                            e.recentBlockhash = _context3.sent;
                            r = e.serializeMessage();
                            i = e._serialize(r).toString("base64");
                            o = [i, {
                              encoding: "base64",
                              commitment: n
                            }];
                            _context3.next = 8;
                            return t._rpcRequest("simulateTransaction", o);

                          case 8:
                            s = _context3.sent;

                            if (!s.error) {
                              _context3.next = 11;
                              break;
                            }

                            throw new Error("failed to simulate transaction: " + s.error.message);

                          case 11:
                            return _context3.abrupt("return", s.result);

                          case 12:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x8, _x9, _x10) {
                    return _ref.apply(this, arguments);
                  };
                }()(this.connection, t, null !== (o = null !== (i = n.commitment) && void 0 !== i ? i : this.opts.commitment) && void 0 !== o ? o : "processed");

              case 11:
                return _context4.abrupt("return", _context4.sent);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function simulate(_x6, _x7) {
        return _simulate.apply(this, arguments);
      }

      return simulate;
    }()
  }], [{
    key: "defaultOptions",
    value: function defaultOptions() {
      return {
        preflightCommitment: "processed",
        commitment: "processed"
      };
    }
  }, {
    key: "local",
    value: function local(t, e) {
      throw new Error("Provider local is not available on browser.");
    }
  }, {
    key: "env",
    value: function env() {
      throw new Error("Provider env is not available on browser.");
    }
  }]);

  return w;
}();

function v(t) {
  _ = t;
}

function b() {
  return null === _ ? w.local() : _;
}

var _ = null;

var A = /*#__PURE__*/function (_Error) {
  _inherits(A, _Error);

  var _super = _createSuper(A);

  function A(t) {
    var _this2;

    _classCallCheck(this, A);

    _this2 = _super.call(this, t), _this2.name = "IdlError";
    return _this2;
  }

  return A;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var E = /*#__PURE__*/function (_Error2) {
  _inherits(E, _Error2);

  var _super2 = _createSuper(E);

  function E(t, e) {
    var _this3;

    _classCallCheck(this, E);

    for (var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      n[_key - 2] = arguments[_key];
    }

    _this3 = _super2.call.apply(_super2, [this].concat(n)), _this3.code = t, _this3.msg = e;
    return _this3;
  }

  _createClass(E, [{
    key: "toString",
    value: function toString() {
      return this.msg;
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      var n,
          r = t.toString().split("custom program error: ");
      if (2 !== r.length) return null;

      try {
        n = parseInt(r[1]);
      } catch (t) {
        return null;
      }

      var i = e.get(n);
      return void 0 !== i ? new E(n, i, n + ": " + i) : (i = I.get(n), void 0 !== i ? new E(n, i, n + ": " + i) : null);
    }
  }]);

  return E;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var I = new Map([[100, "8 byte instruction identifier not provided"], [101, "Fallback functions are not supported"], [102, "The program could not deserialize the given instruction"], [103, "The program could not serialize the given instruction"], [1e3, "The program was compiled without idl instructions"], [1001, "The transaction was given an invalid program for the IDL instruction"], [2e3, "A mut constraint was violated"], [2001, "A has_one constraint was violated"], [2002, "A signer constraint was violated"], [2003, "A raw constraint was violated"], [2004, "An owner constraint was violated"], [2005, "A rent exempt constraint was violated"], [2006, "A seeds constraint was violated"], [2007, "An executable constraint was violated"], [2008, "A state constraint was violated"], [2009, "An associated constraint was violated"], [2010, "An associated init constraint was violated"], [2011, "A close constraint was violated"], [2012, "An address constraint was violated"], [2013, "Expected zero account discriminant"], [2014, "A token mint constraint was violated"], [2015, "A token owner constraint was violated"], [2016, "A mint mint authority constraint was violated"], [2017, "A mint freeze authority constraint was violated"], [2018, "A mint decimals constraint was violated"], [2019, "A space constraint was violated"], [3e3, "The account discriminator was already set on this account"], [3001, "No 8 byte discriminator was found on the account"], [3002, "8 byte discriminator did not match what was expected"], [3003, "Failed to deserialize the account"], [3004, "Failed to serialize the account"], [3005, "Not enough account keys given to the instruction"], [3006, "The given account is not mutable"], [3007, "The given account is owned by a different program than expected"], [3008, "Program ID was not as expected"], [3009, "Program account is not executable"], [3010, "The given account did not sign"], [3011, "The given account is not owned by the system program"], [3012, "The program expected this account to be already initialized"], [3013, "The given account is not a program data account"], [3014, "The given account is not the associated token account"], [4e3, "The given state account does not have the correct address"], [5e3, "The API being used is deprecated and should no longer be used"]]);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _S = function S() {
  return _S = Object.assign || function (t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      for (var i in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
      }
    }

    return t;
  }, _S.apply(this, arguments);
},
    _x11 = function x() {
  return _x11 = Object.assign || function (t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      for (var i in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
      }
    }

    return t;
  }, _x11.apply(this, arguments);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function k(t) {
  return t.toLowerCase();
}

var M = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g],
    L = /[^A-Z0-9]+/gi;

function T(t, e, n) {
  return e instanceof RegExp ? t.replace(e, n) : e.reduce(function (t, e) {
    return t.replace(e, n);
  }, t);
}

function B(t, e) {
  return void 0 === e && (e = {}), function (t, e) {
    void 0 === e && (e = {});

    for (var n = e.splitRegexp, r = void 0 === n ? M : n, i = e.stripRegexp, o = void 0 === i ? L : i, s = e.transform, a = void 0 === s ? k : s, c = e.delimiter, u = void 0 === c ? " " : c, d = T(T(t, r, "$1\0$2"), o, "\0"), l = 0, h = d.length; "\0" === d.charAt(l);) {
      l++;
    }

    for (; "\0" === d.charAt(h - 1);) {
      h--;
    }

    return d.slice(l, h).split("\0").map(a).join(u);
  }(t, _x11({
    delimiter: "."
  }, e));
}

var P = /*#__PURE__*/function () {
  function P() {
    _classCallCheck(this, P);
  }

  _createClass(P, null, [{
    key: "fieldLayout",
    value: function fieldLayout(t, e) {
      var n = void 0 !== t.name ? d(t.name) : void 0;

      switch (t.type) {
        case "bool":
          return h.bool(n);

        case "u8":
          return h.u8(n);

        case "i8":
          return h.i8(n);

        case "u16":
          return h.u16(n);

        case "i16":
          return h.i16(n);

        case "u32":
          return h.u32(n);

        case "i32":
          return h.i32(n);

        case "u64":
          return h.u64(n);

        case "i64":
          return h.i64(n);

        case "u128":
          return h.u128(n);

        case "i128":
          return h.i128(n);

        case "bytes":
          return h.vecU8(n);

        case "string":
          return h.str(n);

        case "publicKey":
          return h.publicKey(n);

        default:
          if ("vec" in t.type) return h.vec(P.fieldLayout({
            name: void 0,
            type: t.type.vec
          }, e), n);
          if ("option" in t.type) return h.option(P.fieldLayout({
            name: void 0,
            type: t.type.option
          }, e), n);

          if ("defined" in t.type) {
            var r = t.type.defined;
            if (void 0 === e) throw new A("User defined types not provided");
            var i = e.filter(function (t) {
              return t.name === r;
            });
            if (1 !== i.length) throw new A("Type not found: ".concat(JSON.stringify(t)));
            return P.typeDefLayout(i[0], e, n);
          }

          if ("array" in t.type) {
            var _r2 = t.type.array[0],
                _i = t.type.array[1],
                o = P.fieldLayout({
              name: void 0,
              type: _r2
            }, e);
            return h.array(o, _i, n);
          }

          throw new Error("Not yet implemented: ".concat(t));
      }
    }
  }, {
    key: "typeDefLayout",
    value: function typeDefLayout(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var n = arguments.length > 2 ? arguments[2] : undefined;

      if ("struct" === t.type.kind) {
        var r = t.type.fields.map(function (t) {
          return P.fieldLayout(t, e);
        });
        return h.struct(r, n);
      }

      if ("enum" === t.type.kind) {
        var _r3 = t.type.variants.map(function (t) {
          var n = d(t.name);
          if (void 0 === t.fields) return h.struct([], n);
          var r = t.fields.map(function (t) {
            if (!t.hasOwnProperty("name")) throw new Error("Tuple enum variants not yet implemented.");
            return P.fieldLayout(t, e);
          });
          return h.struct(r, n);
        });

        return void 0 !== n ? h.rustEnum(_r3).replicate(n) : h.rustEnum(_r3, n);
      }

      throw new Error("Unknown type kint: ".concat(t));
    }
  }]);

  return P;
}();

var O = /*#__PURE__*/function () {
  function O(t) {
    var _this4 = this;

    _classCallCheck(this, O);

    this.idl = t, this.ixLayout = O.parseIxLayout(t);
    var e = new Map();
    t.instructions.forEach(function (t) {
      var n = D("global", t.name);
      e.set(u.encode(n), {
        layout: _this4.ixLayout.get(t.name),
        name: t.name
      });
    }), t.state && t.state.methods.map(function (t) {
      var n = D("state", t.name);
      e.set(u.encode(n), {
        layout: _this4.ixLayout.get(t.name),
        name: t.name
      });
    }), this.sighashLayouts = e;
  }

  _createClass(O, [{
    key: "encode",
    value: function encode(t, e) {
      return this._encode("global", t, e);
    }
  }, {
    key: "encodeState",
    value: function encodeState(t, e) {
      return this._encode("state", t, e);
    }
  }, {
    key: "_encode",
    value: function _encode(e, n, r) {
      var i = t.alloc(1e3),
          o = d(n),
          s = this.ixLayout.get(o);
      if (!s) throw new Error("Unknown method: ".concat(o));
      var a = s.encode(r, i),
          c = i.slice(0, a);
      return t.concat([D(e, n), c]);
    }
  }, {
    key: "decode",
    value: function decode(e) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "hex";
      "string" == typeof e && (e = "hex" === n ? t.from(e, "hex") : u.decode(e));
      var r = u.encode(e.slice(0, 8)),
          i = e.slice(8);
      var o = this.sighashLayouts.get(r);
      return o ? {
        data: o.layout.decode(i),
        name: o.name
      } : null;
    }
  }, {
    key: "format",
    value: function format(t, e) {
      return z.format(t, e, this.idl);
    }
  }], [{
    key: "parseIxLayout",
    value: function parseIxLayout(t) {
      var e = (t.state ? t.state.methods : []).map(function (e) {
        var n = e.args.map(function (e) {
          var n, r;
          return P.fieldLayout(e, Array.from([].concat(_toConsumableArray(null !== (n = t.accounts) && void 0 !== n ? n : []), _toConsumableArray(null !== (r = t.types) && void 0 !== r ? r : []))));
        });
        var r = d(e.name);
        return [r, h.struct(n, r)];
      }).concat(t.instructions.map(function (e) {
        var n = e.args.map(function (e) {
          var n, r;
          return P.fieldLayout(e, Array.from([].concat(_toConsumableArray(null !== (n = t.accounts) && void 0 !== n ? n : []), _toConsumableArray(null !== (r = t.types) && void 0 !== r ? r : []))));
        });
        var r = d(e.name);
        return [r, h.struct(n, r)];
      }));
      return new Map(e);
    }
  }]);

  return O;
}();

var z = /*#__PURE__*/function () {
  function z() {
    _classCallCheck(this, z);
  }

  _createClass(z, null, [{
    key: "format",
    value: function format(t, e, n) {
      var r = n.instructions.filter(function (e) {
        return t.name === e.name;
      })[0];
      if (void 0 === r) return console.error("Invalid instruction given"), null;
      var i = r.args.map(function (e) {
        return {
          name: e.name,
          type: z.formatIdlType(e.type),
          data: z.formatIdlData(e, t.data[e.name], n.types)
        };
      }),
          o = z.flattenIdlAccounts(r.accounts);
      return {
        args: i,
        accounts: e.map(function (t, e) {
          return e < o.length ? _objectSpread({
            name: o[e].name
          }, t) : _objectSpread({
            name: void 0
          }, t);
        })
      };
    }
  }, {
    key: "formatIdlType",
    value: function formatIdlType(t) {
      if ("string" == typeof t) return t;
      if ("vec" in t) return "Vec<".concat(this.formatIdlType(t.vec), ">");
      if ("option" in t) return "Option<".concat(this.formatIdlType(t.option), ">");
      if ("defined" in t) return t.defined;
      if ("array" in t) return "Array<".concat(t.array[0], "; ").concat(t.array[1], ">");
      throw new Error("Unknown IDL type: ".concat(t));
    }
  }, {
    key: "formatIdlData",
    value: function formatIdlData(t, e, n) {
      var _this5 = this;

      if ("string" == typeof t.type) return e.toString();
      if (t.type.hasOwnProperty("vec")) return "[" + e.map(function (e) {
        return _this5.formatIdlData({
          name: "",
          type: t.type.vec
        }, e);
      }).join(", ") + "]";
      if (t.type.hasOwnProperty("option")) return null === e ? "null" : this.formatIdlData({
        name: "",
        type: t.type.option
      }, e);

      if (t.type.hasOwnProperty("defined")) {
        if (void 0 === n) throw new Error("User defined types not provided");
        var r = n.filter(function (e) {
          return e.name === t.type.defined;
        });
        if (1 !== r.length) throw new Error("Type not found: ".concat(t.type.defined));
        return z.formatIdlDataDefined(r[0], e, n);
      }

      return "unknown";
    }
  }, {
    key: "formatIdlDataDefined",
    value: function formatIdlDataDefined(t, e, n) {
      if ("struct" === t.type.kind) {
        var r = t.type;
        return "{ " + Object.keys(e).map(function (t) {
          var i = r.fields.filter(function (e) {
            return e.name === t;
          })[0];
          if (void 0 === i) throw new Error("Unable to find type");
          return t + ": " + z.formatIdlData(i, e[t], n);
        }).join(", ") + " }";
      }

      if (0 === t.type.variants.length) return "{}";

      if (t.type.variants[0].name) {
        var _r4 = t.type.variants,
            i = Object.keys(e)[0],
            o = e[i],
            _s = Object.keys(o).map(function (t) {
          var e;
          var s = o[t],
              a = null === (e = _r4[i]) || void 0 === e ? void 0 : e.filter(function (e) {
            return e.name === t;
          })[0];
          if (void 0 === a) throw new Error("Unable to find variant");
          return t + ": " + z.formatIdlData(a, s, n);
        }).join(", "),
            _a = d(i, {
          pascalCase: !0
        });

        return 0 === _s.length ? _a : "".concat(_a, " { ").concat(_s, " }");
      }

      return "Tuple formatting not yet implemented";
    }
  }, {
    key: "flattenIdlAccounts",
    value: function flattenIdlAccounts(t, e) {
      return t.map(function (t) {
        var n = function (t) {
          var e = t.replace(/([A-Z])/g, " $1");
          return e.charAt(0).toUpperCase() + e.slice(1);
        }(t.name);

        if (t.hasOwnProperty("accounts")) {
          var r = e ? "".concat(e, " > ").concat(n) : n;
          return z.flattenIdlAccounts(t.accounts, r);
        }

        return _objectSpread(_objectSpread({}, t), {}, {
          name: e ? "".concat(e, " > ").concat(n) : n
        });
      }).flat();
    }
  }]);

  return z;
}();

function D(e, n) {
  var r;
  var i = "".concat(e, ":").concat((void 0 === r && (r = {}), B(n, _S({
    delimiter: "_"
  }, r))));
  return t.from(l.digest(i)).slice(0, 8);
}

function U(t, e) {
  if ("enum" === e.type.kind) {
    var _n = e.type.variants.map(function (e) {
      return void 0 === e.fields ? 0 : e.fields.map(function (e) {
        if ("object" != typeof e || !("name" in e)) throw new Error("Tuple enum variants not yet implemented.");
        return j(t, e.type);
      }).reduce(function (t, e) {
        return t + e;
      });
    });

    return Math.max.apply(Math, _toConsumableArray(_n)) + 1;
  }

  return void 0 === e.type.fields ? 0 : e.type.fields.map(function (e) {
    return j(t, e.type);
  }).reduce(function (t, e) {
    return t + e;
  }, 0);
}

function j(t, e) {
  var n, r;

  switch (e) {
    case "bool":
    case "u8":
    case "i8":
    case "bytes":
    case "string":
      return 1;

    case "i16":
    case "u16":
      return 2;

    case "u32":
    case "i32":
      return 4;

    case "u64":
    case "i64":
      return 8;

    case "u128":
    case "i128":
      return 16;

    case "publicKey":
      return 32;

    default:
      if ("vec" in e) return 1;
      if ("option" in e) return 1 + j(t, e.option);
      if ("coption" in e) return 4 + j(t, e.coption);

      if ("defined" in e) {
        var i = null !== (r = null === (n = t.types) || void 0 === n ? void 0 : n.filter(function (t) {
          return t.name === e.defined;
        })) && void 0 !== r ? r : [];
        if (1 !== i.length) throw new A("Type not found: ".concat(JSON.stringify(e)));
        return U(t, i[0]);
      }

      if ("array" in e) {
        var _n2 = e.array[0],
            _r5 = e.array[1];
        return j(t, _n2) * _r5;
      }

      throw new Error("Invalid type ".concat(JSON.stringify(e)));
  }
}

var C = 8;

var $ = /*#__PURE__*/function () {
  function $(t) {
    _classCallCheck(this, $);

    if (void 0 === t.accounts) return void (this.accountLayouts = new Map());
    var e = t.accounts.map(function (e) {
      return [e.name, P.typeDefLayout(e, t.types)];
    });
    this.accountLayouts = new Map(e), this.idl = t;
  }

  _createClass($, [{
    key: "encode",
    value: function () {
      var _encode2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e, n) {
        var r, i, o, s, a;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                r = t.alloc(1e3), i = this.accountLayouts.get(e);

                if (i) {
                  _context5.next = 3;
                  break;
                }

                throw new Error("Unknown account: ".concat(e));

              case 3:
                o = i.encode(n, r);
                s = r.slice(0, o), a = $.accountDiscriminator(e);
                return _context5.abrupt("return", t.concat([a, s]));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function encode(_x12, _x13) {
        return _encode2.apply(this, arguments);
      }

      return encode;
    }()
  }, {
    key: "decode",
    value: function decode(t, e) {
      if ($.accountDiscriminator(t).compare(e.slice(0, 8))) throw new Error("Invalid account discriminator");
      return this.decodeUnchecked(t, e);
    }
  }, {
    key: "decodeUnchecked",
    value: function decodeUnchecked(t, e) {
      var n = e.slice(8),
          r = this.accountLayouts.get(t);
      if (!r) throw new Error("Unknown account: ".concat(t));
      return r.decode(n);
    }
  }, {
    key: "memcmp",
    value: function memcmp(e, n) {
      var r = $.accountDiscriminator(e);
      return {
        offset: 0,
        bytes: u.encode(n ? t.concat([r, n]) : r)
      };
    }
  }, {
    key: "size",
    value: function size(t) {
      var e;
      return 8 + (null !== (e = U(this.idl, t)) && void 0 !== e ? e : 0);
    }
  }], [{
    key: "accountDiscriminator",
    value: function accountDiscriminator(e) {
      return t.from(l.digest("account:".concat(d(e, {
        pascalCase: !0
      })))).slice(0, 8);
    }
  }]);

  return $;
}();

var V = /*#__PURE__*/function () {
  function V(t) {
    _classCallCheck(this, V);

    if (void 0 === t.events) return void (this.layouts = new Map());
    var e = t.events.map(function (e) {
      var n = {
        name: e.name,
        type: {
          kind: "struct",
          fields: e.fields.map(function (t) {
            return {
              name: t.name,
              type: t.type
            };
          })
        }
      };
      return [e.name, P.typeDefLayout(n, t.types)];
    });
    this.layouts = new Map(e), this.discriminators = new Map(void 0 === t.events ? [] : t.events.map(function (t) {
      return [p.fromByteArray(R(t.name)), t.name];
    }));
  }

  _createClass(V, [{
    key: "decode",
    value: function decode(e) {
      var n;

      try {
        n = t.from(p.toByteArray(e));
      } catch (t) {
        return null;
      }

      var r = p.fromByteArray(n.slice(0, 8)),
          i = this.discriminators.get(r);
      if (void 0 === i) return null;
      var o = this.layouts.get(i);
      if (!o) throw new Error("Unknown event: ".concat(i));
      return {
        data: o.decode(n.slice(8)),
        name: i
      };
    }
  }]);

  return V;
}();

function R(e) {
  return t.from(l.digest("event:".concat(e))).slice(0, 8);
}

var K = new Set(["anchor-deprecated-state", "debug-logs"]),
    N = new Map();

function F(t) {
  return void 0 !== N.get(t);
}

var W = Object.freeze({
  __proto__: null,
  set: function set(t) {
    if (!K.has(t)) throw new Error("Invalid feature");
    N.set(t, !0);
  },
  isSet: F
});

var q = /*#__PURE__*/function () {
  function q(t) {
    _classCallCheck(this, q);

    if (void 0 === t.state) throw new Error("Idl state not defined.");
    this.layout = P.typeDefLayout(t.state.struct, t.types);
  }

  _createClass(q, [{
    key: "encode",
    value: function () {
      var _encode3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e, n) {
        var r, i, o, s;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                r = t.alloc(1e3);
                i = this.layout.encode(n, r);
                _context6.next = 4;
                return G(e);

              case 4:
                o = _context6.sent;
                s = r.slice(0, i);
                return _context6.abrupt("return", t.concat([o, s]));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function encode(_x14, _x15) {
        return _encode3.apply(this, arguments);
      }

      return encode;
    }()
  }, {
    key: "decode",
    value: function decode(t) {
      var e = t.slice(8);
      return this.layout.decode(e);
    }
  }]);

  return q;
}();

function G(_x16) {
  return _G.apply(this, arguments);
}

function _G() {
  _G = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(e) {
    var n;
    return _regeneratorRuntime.wrap(function _callee41$(_context41) {
      while (1) {
        switch (_context41.prev = _context41.next) {
          case 0:
            n = F("anchor-deprecated-state") ? "account" : "state";
            return _context41.abrupt("return", t.from(l.digest("".concat(n, ":").concat(e))).slice(0, 8));

          case 2:
          case "end":
            return _context41.stop();
        }
      }
    }, _callee41);
  }));
  return _G.apply(this, arguments);
}

var H = function H(t) {
  _classCallCheck(this, H);

  this.instruction = new O(t), this.accounts = new $(t), this.events = new V(t), t.state && (this.state = new q(t));
};

var J = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function Z(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}

var Q = /*#__PURE__*/function () {
  function Q(t, e) {
    _classCallCheck(this, Q);

    if (!Number.isInteger(t)) throw new TypeError("span must be an integer");
    this.span = t, this.property = e;
  }

  _createClass(Q, [{
    key: "makeDestinationObject",
    value: function makeDestinationObject() {
      return {};
    }
  }, {
    key: "decode",
    value: function decode(t, e) {
      throw new Error("Layout is abstract");
    }
  }, {
    key: "encode",
    value: function encode(t, e, n) {
      throw new Error("Layout is abstract");
    }
  }, {
    key: "getSpan",
    value: function getSpan(t, e) {
      if (0 > this.span) throw new RangeError("indeterminate span");
      return this.span;
    }
  }, {
    key: "replicate",
    value: function replicate(t) {
      var e = Object.create(this.constructor.prototype);
      return Object.assign(e, this), e.property = t, e;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {}
  }]);

  return Q;
}();

var X = Q;

var Y = /*#__PURE__*/function (_Q) {
  _inherits(Y, _Q);

  var _super3 = _createSuper(Y);

  function Y() {
    _classCallCheck(this, Y);

    return _super3.apply(this, arguments);
  }

  _createClass(Y, [{
    key: "isCount",
    value: function isCount() {
      throw new Error("ExternalLayout is abstract");
    }
  }]);

  return Y;
}(Q);

var tt = /*#__PURE__*/function (_Y) {
  _inherits(tt, _Y);

  var _super4 = _createSuper(tt);

  function tt(t, e, n) {
    var _this6;

    _classCallCheck(this, tt);

    if (!(t instanceof Q)) throw new TypeError("layout must be a Layout");
    if (void 0 === e) e = 0;else if (!Number.isInteger(e)) throw new TypeError("offset must be integer or undefined");
    _this6 = _super4.call(this, t.span, n || t.property), _this6.layout = t, _this6.offset = e;
    return _this6;
  }

  _createClass(tt, [{
    key: "isCount",
    value: function isCount() {
      return this.layout instanceof et || this.layout instanceof nt;
    }
  }, {
    key: "decode",
    value: function decode(t, e) {
      return void 0 === e && (e = 0), this.layout.decode(t, e + this.offset);
    }
  }, {
    key: "encode",
    value: function encode(t, e, n) {
      return void 0 === n && (n = 0), this.layout.encode(t, e, n + this.offset);
    }
  }]);

  return tt;
}(Y);

var et = /*#__PURE__*/function (_Q2) {
  _inherits(et, _Q2);

  var _super5 = _createSuper(et);

  function et(t, e) {
    var _this7;

    _classCallCheck(this, et);

    if (_this7 = _super5.call(this, t, e), 6 < _this7.span) throw new RangeError("span must not exceed 6 bytes");
    return _possibleConstructorReturn(_this7);
  }

  _createClass(et, [{
    key: "decode",
    value: function decode(t, e) {
      return void 0 === e && (e = 0), t.readUIntLE(e, this.span);
    }
  }, {
    key: "encode",
    value: function encode(t, e, n) {
      return void 0 === n && (n = 0), e.writeUIntLE(t, n, this.span), this.span;
    }
  }]);

  return et;
}(Q);

var nt = /*#__PURE__*/function (_Q3) {
  _inherits(nt, _Q3);

  var _super6 = _createSuper(nt);

  function nt(t, e) {
    var _this8;

    _classCallCheck(this, nt);

    if (_this8 = _super6.call(this, t, e), 6 < _this8.span) throw new RangeError("span must not exceed 6 bytes");
    return _possibleConstructorReturn(_this8);
  }

  _createClass(nt, [{
    key: "decode",
    value: function decode(t, e) {
      return void 0 === e && (e = 0), t.readUIntBE(e, this.span);
    }
  }, {
    key: "encode",
    value: function encode(t, e, n) {
      return void 0 === n && (n = 0), e.writeUIntBE(t, n, this.span), this.span;
    }
  }]);

  return nt;
}(Q);

var rt = Math.pow(2, 32);

var it = /*#__PURE__*/function (_Q4) {
  _inherits(it, _Q4);

  var _super7 = _createSuper(it);

  function it(t) {
    _classCallCheck(this, it);

    return _super7.call(this, 8, t);
  }

  _createClass(it, [{
    key: "decode",
    value: function decode(t, e) {
      void 0 === e && (e = 0);
      var n = t.readUInt32LE(e);
      return function (t, e) {
        return t * rt + e;
      }(t.readUInt32LE(e + 4), n);
    }
  }, {
    key: "encode",
    value: function encode(t, e, n) {
      void 0 === n && (n = 0);

      var r = function (t) {
        var e = Math.floor(t / rt);
        return {
          hi32: e,
          lo32: t - e * rt
        };
      }(t);

      return e.writeUInt32LE(r.lo32, n), e.writeUInt32LE(r.hi32, n + 4), 8;
    }
  }]);

  return it;
}(Q);

var ot = /*#__PURE__*/function (_Q5) {
  _inherits(ot, _Q5);

  var _super8 = _createSuper(ot);

  function ot(t, e, n) {
    var _this9;

    _classCallCheck(this, ot);

    if (!Array.isArray(t) || !t.reduce(function (t, e) {
      return t && e instanceof Q;
    }, !0)) throw new TypeError("fields must be array of Layout instances");
    "boolean" == typeof e && void 0 === n && (n = e, e = void 0);

    var _iterator = _createForOfIteratorHelper(t),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _e2 = _step.value;
        if (0 > _e2.span && void 0 === _e2.property) throw new Error("fields cannot contain unnamed variable-length layout");
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var r = -1;

    try {
      r = t.reduce(function (t, e) {
        return t + e.getSpan();
      }, 0);
    } catch (t) {}

    _this9 = _super8.call(this, r, e), _this9.fields = t, _this9.decodePrefixes = !!n;
    return _this9;
  }

  _createClass(ot, [{
    key: "getSpan",
    value: function getSpan(t, e) {
      if (0 <= this.span) return this.span;
      void 0 === e && (e = 0);
      var n = 0;

      try {
        n = this.fields.reduce(function (n, r) {
          var i = r.getSpan(t, e);
          return e += i, n + i;
        }, 0);
      } catch (t) {
        throw new RangeError("indeterminate span");
      }

      return n;
    }
  }, {
    key: "decode",
    value: function decode(t, e) {
      void 0 === e && (e = 0);
      var n = this.makeDestinationObject();

      var _iterator2 = _createForOfIteratorHelper(this.fields),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var r = _step2.value;
          if (void 0 !== r.property && (n[r.property] = r.decode(t, e)), e += r.getSpan(t, e), this.decodePrefixes && t.length === e) break;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return n;
    }
  }, {
    key: "encode",
    value: function encode(t, e, n) {
      void 0 === n && (n = 0);
      var r = n;
      var i = 0,
          o = 0;

      var _iterator3 = _createForOfIteratorHelper(this.fields),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _r6 = _step3.value;
          var _s2 = _r6.span;

          if (o = 0 < _s2 ? _s2 : 0, void 0 !== _r6.property) {
            var _i2 = t[_r6.property];
            void 0 !== _i2 && (o = _r6.encode(_i2, e, n), 0 > _s2 && (_s2 = _r6.getSpan(e, n)));
          }

          i = n, n += _s2;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return i + o - r;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = this.makeDestinationObject();

      var _iterator4 = _createForOfIteratorHelper(this.fields),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _n3 = _step4.value;
          void 0 !== _n3.property && 0 < t.length && (e[_n3.property] = t.shift());
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return e;
    }
  }, {
    key: "layoutFor",
    value: function layoutFor(t) {
      if ("string" != typeof t) throw new TypeError("property must be string");

      var _iterator5 = _createForOfIteratorHelper(this.fields),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _e3 = _step5.value;
          if (_e3.property === t) return _e3;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "offsetOf",
    value: function offsetOf(t) {
      if ("string" != typeof t) throw new TypeError("property must be string");
      var e = 0;

      var _iterator6 = _createForOfIteratorHelper(this.fields),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _n4 = _step6.value;
          if (_n4.property === t) return e;
          0 > _n4.span ? e = -1 : 0 <= e && (e += _n4.span);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }]);

  return ot;
}(Q);

var st = /*#__PURE__*/function () {
  function st(t) {
    _classCallCheck(this, st);

    this.property = t;
  }

  _createClass(st, [{
    key: "decode",
    value: function decode() {
      throw new Error("UnionDiscriminator is abstract");
    }
  }, {
    key: "encode",
    value: function encode() {
      throw new Error("UnionDiscriminator is abstract");
    }
  }]);

  return st;
}();

var at = /*#__PURE__*/function (_st) {
  _inherits(at, _st);

  var _super9 = _createSuper(at);

  function at(t, e) {
    var _this10;

    _classCallCheck(this, at);

    if (!(t instanceof Y && t.isCount())) throw new TypeError("layout must be an unsigned integer ExternalLayout");
    _this10 = _super9.call(this, e || t.property || "variant"), _this10.layout = t;
    return _this10;
  }

  _createClass(at, [{
    key: "decode",
    value: function decode(t, e) {
      return this.layout.decode(t, e);
    }
  }, {
    key: "encode",
    value: function encode(t, e, n) {
      return this.layout.encode(t, e, n);
    }
  }]);

  return at;
}(st);

var ct = /*#__PURE__*/function (_Q6) {
  _inherits(ct, _Q6);

  var _super10 = _createSuper(ct);

  function ct(t, e, n) {
    var _this11;

    _classCallCheck(this, ct);

    var r = t instanceof et || t instanceof nt;
    if (r) t = new at(new tt(t));else if (t instanceof Y && t.isCount()) t = new at(t);else if (!(t instanceof st)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (void 0 === e && (e = null), !(null === e || e instanceof Q)) throw new TypeError("defaultLayout must be null or a Layout");

    if (null !== e) {
      if (0 > e.span) throw new Error("defaultLayout must have constant span");
      void 0 === e.property && (e = e.replicate("content"));
    }

    var i = -1;
    e && (i = e.span, 0 <= i && r && (i += t.layout.span)), _this11 = _super10.call(this, i, n), _this11.discriminator = t, _this11.usesPrefixDiscriminator = r, _this11.defaultLayout = e, _this11.registry = {};

    var o = _this11.defaultGetSourceVariant.bind(_assertThisInitialized(_this11));

    _this11.getSourceVariant = function (t) {
      return o(t);
    }, _this11.configGetSourceVariant = function (t) {
      o = t.bind(this);
    };
    return _this11;
  }

  _createClass(ct, [{
    key: "getSpan",
    value: function getSpan(t, e) {
      if (0 <= this.span) return this.span;
      void 0 === e && (e = 0);
      var n = this.getVariant(t, e);
      if (!n) throw new Error("unable to determine span for unrecognized variant");
      return n.getSpan(t, e);
    }
  }, {
    key: "defaultGetSourceVariant",
    value: function defaultGetSourceVariant(t) {
      if (t.hasOwnProperty(this.discriminator.property)) {
        if (this.defaultLayout && t.hasOwnProperty(this.defaultLayout.property)) return;
        var _e4 = this.registry[t[this.discriminator.property]];
        if (_e4 && (!_e4.layout || t.hasOwnProperty(_e4.property))) return _e4;
      } else for (var _e5 in this.registry) {
        var _n5 = this.registry[_e5];
        if (t.hasOwnProperty(_n5.property)) return _n5;
      }

      throw new Error("unable to infer src variant");
    }
  }, {
    key: "decode",
    value: function decode(t, e) {
      var n;
      void 0 === e && (e = 0);
      var r = this.discriminator,
          i = r.decode(t, e);
      var o = this.registry[i];

      if (void 0 === o) {
        var _s3 = 0;
        o = this.defaultLayout, this.usesPrefixDiscriminator && (_s3 = r.layout.span), n = this.makeDestinationObject(), n[r.property] = i, n[o.property] = this.defaultLayout.decode(t, e + _s3);
      } else n = o.decode(t, e);

      return n;
    }
  }, {
    key: "encode",
    value: function encode(t, e, n) {
      void 0 === n && (n = 0);
      var r = this.getSourceVariant(t);

      if (void 0 === r) {
        var _r7 = this.discriminator,
            i = this.defaultLayout;
        var o = 0;
        return this.usesPrefixDiscriminator && (o = _r7.layout.span), _r7.encode(t[_r7.property], e, n), o + i.encode(t[i.property], e, n + o);
      }

      return r.encode(t, e, n);
    }
  }, {
    key: "addVariant",
    value: function addVariant(t, e, n) {
      var r = new ut(this, t, e, n);
      return this.registry[t] = r, r;
    }
  }, {
    key: "getVariant",
    value: function getVariant(t, e) {
      var n = t;
      return Buffer.isBuffer(t) && (void 0 === e && (e = 0), n = this.discriminator.decode(t, e)), this.registry[n];
    }
  }]);

  return ct;
}(Q);

var ut = /*#__PURE__*/function (_Q7) {
  _inherits(ut, _Q7);

  var _super11 = _createSuper(ut);

  function ut(t, e, n, r) {
    var _this12;

    _classCallCheck(this, ut);

    if (!(t instanceof ct)) throw new TypeError("union must be a Union");
    if (!Number.isInteger(e) || 0 > e) throw new TypeError("variant must be a (non-negative) integer");

    if ("string" == typeof n && void 0 === r && (r = n, n = null), n) {
      if (!(n instanceof Q)) throw new TypeError("layout must be a Layout");
      if (null !== t.defaultLayout && 0 <= n.span && n.span > t.defaultLayout.span) throw new Error("variant span exceeds span of containing union");
      if ("string" != typeof r) throw new TypeError("variant must have a String property");
    }

    var i = t.span;
    0 > t.span && (i = n ? n.span : 0, 0 <= i && t.usesPrefixDiscriminator && (i += t.discriminator.layout.span)), _this12 = _super11.call(this, i, r), _this12.union = t, _this12.variant = e, _this12.layout = n || null;
    return _this12;
  }

  _createClass(ut, [{
    key: "getSpan",
    value: function getSpan(t, e) {
      if (0 <= this.span) return this.span;
      void 0 === e && (e = 0);
      var n = 0;
      return this.union.usesPrefixDiscriminator && (n = this.union.discriminator.layout.span), n + this.layout.getSpan(t, e + n);
    }
  }, {
    key: "decode",
    value: function decode(t, e) {
      var n = this.makeDestinationObject();
      if (void 0 === e && (e = 0), this !== this.union.getVariant(t, e)) throw new Error("variant mismatch");
      var r = 0;
      return this.union.usesPrefixDiscriminator && (r = this.union.discriminator.layout.span), this.layout ? n[this.property] = this.layout.decode(t, e + r) : this.property ? n[this.property] = !0 : this.union.usesPrefixDiscriminator && (n[this.union.discriminator.property] = this.variant), n;
    }
  }, {
    key: "encode",
    value: function encode(t, e, n) {
      void 0 === n && (n = 0);
      var r = 0;
      if (this.union.usesPrefixDiscriminator && (r = this.union.discriminator.layout.span), this.layout && !t.hasOwnProperty(this.property)) throw new TypeError("variant lacks property " + this.property);
      this.union.discriminator.encode(this.variant, e, n);
      var i = r;
      if (this.layout && (this.layout.encode(t[this.property], e, n + r), i += this.layout.getSpan(e, n + r), 0 <= this.union.span && i > this.union.span)) throw new Error("encoded variant overruns containing union");
      return i;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      if (this.layout) return this.layout.fromArray(t);
    }
  }]);

  return ut;
}(Q);

var dt = /*#__PURE__*/function (_Q8) {
  _inherits(dt, _Q8);

  var _super12 = _createSuper(dt);

  function dt(t, e) {
    var _this13;

    _classCallCheck(this, dt);

    if (!(t instanceof Y && t.isCount() || Number.isInteger(t) && 0 <= t)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    var n = -1;
    t instanceof Y || (n = t), _this13 = _super12.call(this, n, e), _this13.length = t;
    return _this13;
  }

  _createClass(dt, [{
    key: "getSpan",
    value: function getSpan(t, e) {
      var n = this.span;
      return 0 > n && (n = this.length.decode(t, e)), n;
    }
  }, {
    key: "decode",
    value: function decode(t, e) {
      void 0 === e && (e = 0);
      var n = this.span;
      return 0 > n && (n = this.length.decode(t, e)), t.slice(e, e + n);
    }
  }, {
    key: "encode",
    value: function encode(t, e, n) {
      var r = this.length;
      if (this.length instanceof Y && (r = t.length), !Buffer.isBuffer(t) || r !== t.length) throw new TypeError((i = "Blob.encode", ((o = this).property ? i + "[" + o.property + "]" : i) + " requires (length " + r + ") Buffer as src"));
      var i, o;
      if (n + r > e.length) throw new RangeError("encoding overruns Buffer");
      return e.write(t.toString("hex"), n, r, "hex"), this.length instanceof Y && this.length.encode(r, e, n), r;
    }
  }]);

  return dt;
}(Q);

var lt = function lt(t) {
  return new et(1, t);
},
    ht = function ht(t) {
  return new it(t);
},
    pt = function pt(t, e, n) {
  return new ot(t, e, n);
},
    ft = function ft(t, e) {
  return new dt(t, e);
};

var mt = /*#__PURE__*/function () {
  function mt(t) {
    _classCallCheck(this, mt);
  }

  _createClass(mt, [{
    key: "encode",
    value: function encode(t, e) {
      switch (d(t)) {
        case "initializeMint":
          return function (_ref2) {
            var t = _ref2.decimals,
                e = _ref2.mintAuthority,
                r = _ref2.freezeAuthority;
            return _t({
              initializeMint: {
                decimals: t,
                mintAuthority: e.toBuffer(),
                freezeAuthorityOption: !!r,
                freezeAuthority: (r || n.default).toBuffer()
              }
            });
          }(e);

        case "initializeAccount":
          return _t({
            initializeAccount: {}
          });

        case "initializeMultisig":
          return function (_ref3) {
            var t = _ref3.m;
            return _t({
              initializeMultisig: {
                m: t
              }
            });
          }(e);

        case "transfer":
          return function (_ref4) {
            var t = _ref4.amount;
            return _t({
              transfer: {
                amount: t
              }
            });
          }(e);

        case "approve":
          return function (_ref5) {
            var t = _ref5.amount;
            return _t({
              approve: {
                amount: t
              }
            });
          }(e);

        case "revoke":
          return _t({
            revoke: {}
          });

        case "setAuthority":
          return function (_ref6) {
            var t = _ref6.authorityType,
                e = _ref6.newAuthority;
            return _t({
              setAuthority: {
                authorityType: t,
                newAuthority: e
              }
            });
          }(e);

        case "mintTo":
          return function (_ref7) {
            var t = _ref7.amount;
            return _t({
              mintTo: {
                amount: t
              }
            });
          }(e);

        case "burn":
          return function (_ref8) {
            var t = _ref8.amount;
            return _t({
              burn: {
                amount: t
              }
            });
          }(e);

        case "closeAccount":
          return _t({
            closeAccount: {}
          });

        case "freezeAccount":
          return _t({
            freezeAccount: {}
          });

        case "thawAccount":
          return _t({
            thawAccount: {}
          });

        case "transferChecked":
          return function (_ref9) {
            var t = _ref9.amount,
                e = _ref9.decimals;
            return _t({
              transferChecked: {
                amount: t,
                decimals: e
              }
            });
          }(e);

        case "approvedChecked":
          return function (_ref10) {
            var t = _ref10.amount,
                e = _ref10.decimals;
            return _t({
              approveChecked: {
                amount: t,
                decimals: e
              }
            });
          }(e);

        case "mintToChecked":
          return function (_ref11) {
            var t = _ref11.amount,
                e = _ref11.decimals;
            return _t({
              mintToChecked: {
                amount: t,
                decimals: e
              }
            });
          }(e);

        case "burnChecked":
          return function (_ref12) {
            var t = _ref12.amount,
                e = _ref12.decimals;
            return _t({
              burnChecked: {
                amount: t,
                decimals: e
              }
            });
          }(e);

        case "intializeAccount2":
          return function (_ref13) {
            var t = _ref13.authority;
            return _t({
              initilaizeAccount2: {
                authority: t
              }
            });
          }(e);

        case "syncNative":
          return _t({
            syncNative: {}
          });

        case "initializeAccount3":
          return function (_ref14) {
            var t = _ref14.authority;
            return _t({
              initializeAccount3: {
                authority: t
              }
            });
          }(e);

        case "initializeMultisig2":
          return function (_ref15) {
            var t = _ref15.m;
            return _t({
              initializeMultisig2: {
                m: t
              }
            });
          }(e);

        case "initializeMint2":
          return function (_ref16) {
            var t = _ref16.decimals,
                e = _ref16.mintAuthority,
                n = _ref16.freezeAuthority;
            return _t({
              encodeInitializeMint2: {
                decimals: t,
                mintAuthority: e,
                freezeAuthority: n
              }
            });
          }(e);

        default:
          throw new Error("Invalid instruction: ".concat(t));
      }
    }
  }, {
    key: "encodeState",
    value: function encodeState(t, e) {
      throw new Error("SPL token does not have state");
    }
  }]);

  return mt;
}();

var yt = (gt = lt("instruction"), new ct(gt, wt, vt));
var gt, wt, vt;

function bt(t) {
  return ft(32, t);
}

function _t(t) {
  var e = Buffer.alloc(At),
      n = yt.encode(t, e);
  return e.slice(0, n);
}

yt.addVariant(0, pt([lt("decimals"), ft(32, "mintAuthority"), lt("freezeAuthorityOption"), bt("freezeAuthority")]), "initializeMint"), yt.addVariant(1, pt([]), "initializeAccount"), yt.addVariant(2, pt([lt("m")]), "initializeMultisig"), yt.addVariant(3, pt([ht("amount")]), "transfer"), yt.addVariant(4, pt([ht("amount")]), "approve"), yt.addVariant(5, pt([]), "revoke"), yt.addVariant(6, pt([lt("authorityType"), lt("newAuthorityOption"), bt("newAuthority")]), "setAuthority"), yt.addVariant(7, pt([ht("amount")]), "mintTo"), yt.addVariant(8, pt([ht("amount")]), "burn"), yt.addVariant(9, pt([]), "closeAccount"), yt.addVariant(10, pt([]), "freezeAccount"), yt.addVariant(11, pt([]), "thawAccount"), yt.addVariant(12, pt([ht("amount"), lt("decimals")]), "transferChecked"), yt.addVariant(13, pt([ht("amount"), lt("decimals")]), "approvedChecked"), yt.addVariant(14, pt([ht("amount"), lt("decimals")]), "mintToChecked"), yt.addVariant(15, pt([ht("amount"), lt("decimals")]), "burnedChecked"), yt.addVariant(16, pt([bt("authority")]), "InitializeAccount2"), yt.addVariant(17, pt([]), "syncNative"), yt.addVariant(18, pt([bt("authority")]), "initializeAccount3"), yt.addVariant(19, pt([lt("m")]), "initializeMultisig2"), yt.addVariant(20, pt([lt("decimals"), bt("mintAuthority"), lt("freezeAuthorityOption"), bt("freezeAuthority")]), "initializeMint2");
var At = Math.max.apply(Math, _toConsumableArray(Object.values(yt.registry).map(function (t) {
  return t.span;
})));

var Et = /*#__PURE__*/function () {
  function Et(t) {
    _classCallCheck(this, Et);
  }

  _createClass(Et, [{
    key: "encode",
    value: function encode(t, e) {
      throw new Error("SPL token does not have state");
    }
  }, {
    key: "decode",
    value: function decode(t) {
      throw new Error("SPL token does not have state");
    }
  }]);

  return Et;
}();

function It(t) {
  return new kt(ft(8), function (t) {
    return Bt.fromBuffer(t);
  }, function (t) {
    return t.toBuffer();
  }, t);
}

function St(t) {
  return new kt(ft(32), function (t) {
    return new n(t);
  }, function (t) {
    return t.toBuffer();
  }, t);
}

function xt(t, e) {
  return new Mt(t, e);
}

var kt = /*#__PURE__*/function (_X) {
  _inherits(kt, _X);

  var _super13 = _createSuper(kt);

  function kt(t, e, n, r) {
    var _this14;

    _classCallCheck(this, kt);

    _this14 = _super13.call(this, t.span, r), _this14.layout = t, _this14.decoder = e, _this14.encoder = n;
    return _this14;
  }

  _createClass(kt, [{
    key: "decode",
    value: function decode(t, e) {
      return this.decoder(this.layout.decode(t, e));
    }
  }, {
    key: "encode",
    value: function encode(t, e, n) {
      return this.layout.encode(this.encoder(t), e, n);
    }
  }, {
    key: "getSpan",
    value: function getSpan(t, e) {
      return this.layout.getSpan(t, e);
    }
  }]);

  return kt;
}(X);

var Mt = /*#__PURE__*/function (_X2) {
  _inherits(Mt, _X2);

  var _super14 = _createSuper(Mt);

  function Mt(t, e) {
    var _this15;

    _classCallCheck(this, Mt);

    _this15 = _super14.call(this, -1, e), _this15.layout = t, _this15.discriminator = function (t) {
      return new et(4, t);
    }();
    return _this15;
  }

  _createClass(Mt, [{
    key: "encode",
    value: function encode(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return null == t ? this.layout.span + this.discriminator.encode(0, e, n) : (this.discriminator.encode(1, e, n), this.layout.encode(t, e, n + 4) + 4);
    }
  }, {
    key: "decode",
    value: function decode(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = this.discriminator.decode(t, e);
      if (0 === n) return null;
      if (1 === n) return this.layout.decode(t, e + 4);
      throw new Error("Invalid coption " + this.property);
    }
  }, {
    key: "getSpan",
    value: function getSpan(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.layout.getSpan(t, e + 4) + 4;
    }
  }]);

  return Mt;
}(X);

function Lt(t) {
  if (0 === t) return !1;
  if (1 === t) return !0;
  throw new Error("Invalid bool: " + t);
}

function Tt(t) {
  return t ? 1 : 0;
}

var Bt = /*#__PURE__*/function (_c) {
  _inherits(Bt, _c);

  var _super15 = _createSuper(Bt);

  function Bt() {
    _classCallCheck(this, Bt);

    return _super15.apply(this, arguments);
  }

  _createClass(Bt, [{
    key: "toBuffer",
    value: function toBuffer() {
      var t = _get(_getPrototypeOf(Bt.prototype), "toArray", this).call(this).reverse(),
          e = Buffer.from(t);

      if (8 === e.length) return e;
      if (e.length >= 8) throw new Error("u64 too large");
      var n = Buffer.alloc(8);
      return e.copy(n), n;
    }
  }], [{
    key: "fromBuffer",
    value: function fromBuffer(t) {
      if (8 !== t.length) throw new Error("Invalid buffer length: ".concat(t.length));
      return new Bt(_toConsumableArray(t).reverse().map(function (t) {
        return "00".concat(t.toString(16)).slice(-2);
      }).join(""), 16);
    }
  }]);

  return Bt;
}(c);

var Pt = /*#__PURE__*/function () {
  function Pt(t) {
    _classCallCheck(this, Pt);

    this.idl = t;
  }

  _createClass(Pt, [{
    key: "encode",
    value: function () {
      var _encode4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(t, e) {
        var _t3, _n6, _t4, _n7;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.t0 = t;
                _context7.next = _context7.t0 === "Token" ? 3 : _context7.t0 === "Mint" ? 5 : 7;
                break;

              case 3:
                _t3 = Buffer.alloc(165), _n6 = zt.encode(e, _t3);
                return _context7.abrupt("return", _t3.slice(0, _n6));

              case 5:
                _t4 = Buffer.alloc(82), _n7 = Ot.encode(e, _t4);
                return _context7.abrupt("return", _t4.slice(0, _n7));

              case 7:
                throw new Error("Invalid account name: ".concat(t));

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function encode(_x17, _x18) {
        return _encode4.apply(this, arguments);
      }

      return encode;
    }()
  }, {
    key: "decode",
    value: function decode(t, e) {
      return this.decodeUnchecked(t, e);
    }
  }, {
    key: "decodeUnchecked",
    value: function decodeUnchecked(t, e) {
      switch (t) {
        case "Token":
          return function (t) {
            return zt.decode(t);
          }(e);

        case "Mint":
          return function (t) {
            return Ot.decode(t);
          }(e);

        default:
          throw new Error("Invalid account name: ".concat(t));
      }
    }
  }, {
    key: "memcmp",
    value: function memcmp(t, e) {
      switch (t) {
        case "Token":
          return {
            dataSize: 165
          };

        case "Mint":
          return {
            dataSize: 82
          };

        default:
          throw new Error("Invalid account name: ".concat(t));
      }
    }
  }, {
    key: "size",
    value: function size(t) {
      var e;
      return null !== (e = U(this.idl, t)) && void 0 !== e ? e : 0;
    }
  }]);

  return Pt;
}();

var Ot = pt([xt(St(), "mintAuthority"), It("supply"), lt("decimals"), function (t) {
  return new kt(lt(), Lt, Tt, t);
}("isInitialized"), xt(St(), "freezeAuthority")]),
    zt = pt([St("mint"), St("authority"), It("amount"), xt(St(), "delegate"), lt("state"), xt(It(), "isNative"), It("delegatedAmount"), xt(St(), "closeAuthority")]);

var Dt = /*#__PURE__*/function () {
  function Dt(t) {
    _classCallCheck(this, Dt);
  }

  _createClass(Dt, [{
    key: "decode",
    value: function decode(t) {
      throw new Error("SPL token program does not have events");
    }
  }]);

  return Dt;
}();

var Ut = function Ut(t) {
  _classCallCheck(this, Ut);

  this.instruction = new mt(t), this.accounts = new Pt(t), this.events = new Dt(t), this.state = new Et(t);
};

var jt = Object.freeze({
  __proto__: null,
  hash: function hash(t) {
    return l(t);
  }
});

function Ct(t) {
  var e = new Map();
  return t.errors && t.errors.forEach(function (t) {
    var n;
    var r = null !== (n = t.msg) && void 0 !== n ? n : t.name;
    e.set(t.code, r);
  }), e;
}

function $t(t) {
  for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    e[_key2 - 1] = arguments[_key2];
  }

  if (t.args.length != e.length) throw new Error("Invalid argument length");
  var n = {};
  var r = 0;
  return t.args.forEach(function (t) {
    n[t.name] = e[r], r += 1;
  }), n;
}

function Vt(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  t.forEach(function (t) {
    if ("accounts" in t) Vt(t.accounts, e[t.name]);else if (void 0 === e[t.name]) throw new Error("Invalid arguments: ".concat(t.name, " not provided."));
  });
}

function Rt(t) {
  return t instanceof n ? t : new n(t);
}

function Kt(_x19, _x20, _x21) {
  return _Kt.apply(this, arguments);
}

function _Kt() {
  _Kt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(t, e, n) {
    var _o2, r, i;

    return _regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) {
        switch (_context42.prev = _context42.next) {
          case 0:
            if (!(e.length <= 99)) {
              _context42.next = 4;
              break;
            }

            _context42.next = 3;
            return Nt(t, e, n);

          case 3:
            return _context42.abrupt("return", _context42.sent);

          case 4:
            _o2 = (r = e, i = 99, Array.apply(0, new Array(Math.ceil(r.length / i))).map(function (t, e) {
              return r.slice(e * i, (e + 1) * i);
            }));
            _context42.next = 7;
            return Promise.all(_o2.map(function (e) {
              return Nt(t, e, n);
            }));

          case 7:
            return _context42.abrupt("return", _context42.sent.flat());

          case 8:
          case "end":
            return _context42.stop();
        }
      }
    }, _callee42);
  }));
  return _Kt.apply(this, arguments);
}

function Nt(_x22, _x23, _x24) {
  return _Nt.apply(this, arguments);
}

function _Nt() {
  _Nt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(e, r, i) {
    var o, s, a, c, _iterator7, _step7, _e11, _r14, _i5, _o3, _s5, _a2;

    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            o = null != i ? i : e.commitment, s = [r.map(function (t) {
              return t.toBase58();
            })];
            o && s.push({
              commitment: o
            });
            _context43.next = 4;
            return e._rpcRequest("getMultipleAccounts", s);

          case 4:
            a = _context43.sent;

            if (!a.error) {
              _context43.next = 7;
              break;
            }

            throw new Error("failed to get info about accounts " + r.map(function (t) {
              return t.toBase58();
            }).join(", ") + ": " + a.error.message);

          case 7:
            m(void 0 !== a.result);
            c = [];
            _iterator7 = _createForOfIteratorHelper(a.result.value);
            _context43.prev = 10;

            _iterator7.s();

          case 12:
            if ((_step7 = _iterator7.n()).done) {
              _context43.next = 25;
              break;
            }

            _e11 = _step7.value;
            _r14 = null;

            if (!(null !== _e11)) {
              _context43.next = 22;
              break;
            }

            if (a.result.value) {
              _i5 = _e11.executable, _o3 = _e11.owner, _s5 = _e11.lamports, _a2 = _e11.data;
              m("base64" === _a2[1]), _r14 = {
                executable: _i5,
                owner: new n(_o3),
                lamports: _s5,
                data: t.from(_a2[0], "base64")
              };
            }

            if (!(null === _r14)) {
              _context43.next = 19;
              break;
            }

            throw new Error("Invalid response");

          case 19:
            c.push(_r14);
            _context43.next = 23;
            break;

          case 22:
            c.push(null);

          case 23:
            _context43.next = 12;
            break;

          case 25:
            _context43.next = 30;
            break;

          case 27:
            _context43.prev = 27;
            _context43.t0 = _context43["catch"](10);

            _iterator7.e(_context43.t0);

          case 30:
            _context43.prev = 30;

            _iterator7.f();

            return _context43.finish(30);

          case 33:
            return _context43.abrupt("return", c.map(function (t, e) {
              return null === t ? null : {
                publicKey: r[e],
                account: t
              };
            }));

          case 34:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee43, null, [[10, 27, 30, 33]]);
  }));
  return _Nt.apply(this, arguments);
}

var Ft = Object.freeze({
  __proto__: null,
  invoke: function () {
    var _invoke = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(t, e, n, o) {
      var s;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              t = Rt(t), o || (o = b());
              s = new r();
              s.add(new i({
                programId: t,
                keys: null != e ? e : [],
                data: n
              }));
              _context8.next = 5;
              return o.send(s);

            case 5:
              return _context8.abrupt("return", _context8.sent);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function invoke(_x25, _x26, _x27, _x28) {
      return _invoke.apply(this, arguments);
    }

    return invoke;
  }(),
  getMultipleAccounts: Kt
});

function Wt(e, r, i) {
  var o = t.concat([e.toBuffer(), t.from(r), i.toBuffer()]),
      s = l.digest(o);
  return new n(t.from(s));
}

function qt(e, r) {
  var i = t.alloc(0);
  e.forEach(function (e) {
    if (e.length > 32) throw new TypeError("Max seed length exceeded");
    i = t.concat([i, Ht(e)]);
  }), i = t.concat([i, r.toBuffer(), t.from("ProgramDerivedAddress")]);
  var o = l(new Uint8Array(i)),
      s = new c(o, 16).toArray(void 0, 32);
  if (n.isOnCurve(new Uint8Array(s))) throw new Error("Invalid seeds, address must fall off the curve");
  return new n(s);
}

function Gt(e, n) {
  var r,
      i = 255;

  for (; 0 != i;) {
    try {
      r = qt(e.concat(t.from([i])), n);
    } catch (t) {
      if (t instanceof TypeError) throw t;
      i--;
      continue;
    }

    return [r, i];
  }

  throw new Error("Unable to find a viable program address nonce");
}

var Ht = function Ht(e) {
  return e instanceof t ? e : e instanceof Uint8Array ? t.from(e.buffer, e.byteOffset, e.byteLength) : t.from(e);
};

function Jt(_x29) {
  return _Jt.apply(this, arguments);
}

function _Jt() {
  _Jt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(e) {
    var i,
        _len3,
        r,
        _key3,
        _yield$n$findProgramA3,
        _yield$n$findProgramA4,
        o,
        _args44 = arguments;

    return _regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            i = [t.from([97, 110, 99, 104, 111, 114])];

            for (_len3 = _args44.length, r = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
              r[_key3 - 1] = _args44[_key3];
            }

            r.forEach(function (e) {
              i.push(e instanceof t ? e : Rt(e).toBuffer());
            });
            _context44.next = 5;
            return n.findProgramAddress(i, Rt(e));

          case 5:
            _yield$n$findProgramA3 = _context44.sent;
            _yield$n$findProgramA4 = _slicedToArray(_yield$n$findProgramA3, 1);
            o = _yield$n$findProgramA4[0];
            return _context44.abrupt("return", o);

          case 9:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee44);
  }));
  return _Jt.apply(this, arguments);
}

var Zt = Object.freeze({
  __proto__: null,
  createWithSeedSync: Wt,
  createProgramAddressSync: qt,
  findProgramAddressSync: Gt,
  associated: Jt
});
var Qt = Object.freeze({
  __proto__: null,
  encode: function encode(t) {
    return t.reduce(function (t, e) {
      return t + e.toString(16).padStart(2, "0");
    }, "0x");
  },
  decode: function decode(e) {
    0 === e.indexOf("0x") && (e = e.substr(2)), e.length % 2 == 1 && (e = "0" + e);
    var n = e.match(/.{2}/g);
    return null === n ? t.from([]) : t.from(n.map(function (t) {
      return parseInt(t, 16);
    }));
  }
});

function Xt(t) {
  return new TextDecoder("utf-8").decode(t);
}

function Yt(t) {
  return new TextEncoder().encode(t);
}

var te = Object.freeze({
  __proto__: null,
  decode: Xt,
  encode: Yt
});
var ee = Object.freeze({
  __proto__: null,
  encode: function encode(t) {
    return u.encode(t);
  },
  decode: function decode(t) {
    return u.decode(t);
  }
});
var ne = Object.freeze({
  __proto__: null,
  encode: function encode(t) {
    return p.fromByteArray(t);
  },
  decode: function decode(e) {
    return t.from(p.toByteArray(e));
  }
}),
    re = Object.freeze({
  __proto__: null,
  hex: Qt,
  utf8: te,
  bs58: ee,
  base64: ne
});
var ie = new n("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"),
    oe = new n("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
var se = Object.freeze({
  __proto__: null,
  TOKEN_PROGRAM_ID: ie,
  ASSOCIATED_PROGRAM_ID: oe,
  associatedAddress: function () {
    var _associatedAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref17) {
      var t, e;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              t = _ref17.mint, e = _ref17.owner;
              _context9.next = 3;
              return n.findProgramAddress([e.toBuffer(), ie.toBuffer(), t.toBuffer()], oe);

            case 3:
              return _context9.abrupt("return", _context9.sent[0]);

            case 4:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    function associatedAddress(_x30) {
      return _associatedAddress.apply(this, arguments);
    }

    return associatedAddress;
  }()
}),
    ae = {
  exports: {}
};
!function (t, e) {
  var n = "undefined" != typeof self ? self : J,
      r = function () {
    function t() {
      this.fetch = !1, this.DOMException = n.DOMException;
    }

    return t.prototype = n, new t();
  }();

  !function (t) {
    !function (e) {
      var n = ("URLSearchParams" in t),
          r = "Symbol" in t && "iterator" in Symbol,
          i = "FileReader" in t && "Blob" in t && function () {
        try {
          return new Blob(), !0;
        } catch (t) {
          return !1;
        }
      }(),
          o = ("FormData" in t),
          s = ("ArrayBuffer" in t);

      if (s) var a = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
          c = ArrayBuffer.isView || function (t) {
        return t && a.indexOf(Object.prototype.toString.call(t)) > -1;
      };

      function u(t) {
        if ("string" != typeof t && (t = String(t)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(t)) throw new TypeError("Invalid character in header field name");
        return t.toLowerCase();
      }

      function d(t) {
        return "string" != typeof t && (t = String(t)), t;
      }

      function l(t) {
        var e = {
          next: function next() {
            var e = t.shift();
            return {
              done: void 0 === e,
              value: e
            };
          }
        };
        return r && (e[Symbol.iterator] = function () {
          return e;
        }), e;
      }

      function h(t) {
        this.map = {}, t instanceof h ? t.forEach(function (t, e) {
          this.append(e, t);
        }, this) : Array.isArray(t) ? t.forEach(function (t) {
          this.append(t[0], t[1]);
        }, this) : t && Object.getOwnPropertyNames(t).forEach(function (e) {
          this.append(e, t[e]);
        }, this);
      }

      function p(t) {
        if (t.bodyUsed) return Promise.reject(new TypeError("Already read"));
        t.bodyUsed = !0;
      }

      function f(t) {
        return new Promise(function (e, n) {
          t.onload = function () {
            e(t.result);
          }, t.onerror = function () {
            n(t.error);
          };
        });
      }

      function m(t) {
        var e = new FileReader(),
            n = f(e);
        return e.readAsArrayBuffer(t), n;
      }

      function y(t) {
        if (t.slice) return t.slice(0);
        var e = new Uint8Array(t.byteLength);
        return e.set(new Uint8Array(t)), e.buffer;
      }

      function g() {
        return this.bodyUsed = !1, this._initBody = function (t) {
          var e;
          this._bodyInit = t, t ? "string" == typeof t ? this._bodyText = t : i && Blob.prototype.isPrototypeOf(t) ? this._bodyBlob = t : o && FormData.prototype.isPrototypeOf(t) ? this._bodyFormData = t : n && URLSearchParams.prototype.isPrototypeOf(t) ? this._bodyText = t.toString() : s && i && (e = t) && DataView.prototype.isPrototypeOf(e) ? (this._bodyArrayBuffer = y(t.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : s && (ArrayBuffer.prototype.isPrototypeOf(t) || c(t)) ? this._bodyArrayBuffer = y(t) : this._bodyText = t = Object.prototype.toString.call(t) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof t ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n && URLSearchParams.prototype.isPrototypeOf(t) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, i && (this.blob = function () {
          var t = p(this);
          if (t) return t;
          if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData) throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function () {
          return this._bodyArrayBuffer ? p(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(m);
        }), this.text = function () {
          var t = p(this);
          if (t) return t;
          if (this._bodyBlob) return function (t) {
            var e = new FileReader(),
                n = f(e);
            return e.readAsText(t), n;
          }(this._bodyBlob);
          if (this._bodyArrayBuffer) return Promise.resolve(function (t) {
            for (var e = new Uint8Array(t), n = new Array(e.length), r = 0; r < e.length; r++) {
              n[r] = String.fromCharCode(e[r]);
            }

            return n.join("");
          }(this._bodyArrayBuffer));
          if (this._bodyFormData) throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, o && (this.formData = function () {
          return this.text().then(b);
        }), this.json = function () {
          return this.text().then(JSON.parse);
        }, this;
      }

      h.prototype.append = function (t, e) {
        t = u(t), e = d(e);
        var n = this.map[t];
        this.map[t] = n ? n + ", " + e : e;
      }, h.prototype.delete = function (t) {
        delete this.map[u(t)];
      }, h.prototype.get = function (t) {
        return t = u(t), this.has(t) ? this.map[t] : null;
      }, h.prototype.has = function (t) {
        return this.map.hasOwnProperty(u(t));
      }, h.prototype.set = function (t, e) {
        this.map[u(t)] = d(e);
      }, h.prototype.forEach = function (t, e) {
        for (var n in this.map) {
          this.map.hasOwnProperty(n) && t.call(e, this.map[n], n, this);
        }
      }, h.prototype.keys = function () {
        var t = [];
        return this.forEach(function (e, n) {
          t.push(n);
        }), l(t);
      }, h.prototype.values = function () {
        var t = [];
        return this.forEach(function (e) {
          t.push(e);
        }), l(t);
      }, h.prototype.entries = function () {
        var t = [];
        return this.forEach(function (e, n) {
          t.push([n, e]);
        }), l(t);
      }, r && (h.prototype[Symbol.iterator] = h.prototype.entries);
      var w = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];

      function v(t, e) {
        var n,
            r,
            i = (e = e || {}).body;

        if (t instanceof v) {
          if (t.bodyUsed) throw new TypeError("Already read");
          this.url = t.url, this.credentials = t.credentials, e.headers || (this.headers = new h(t.headers)), this.method = t.method, this.mode = t.mode, this.signal = t.signal, i || null == t._bodyInit || (i = t._bodyInit, t.bodyUsed = !0);
        } else this.url = String(t);

        if (this.credentials = e.credentials || this.credentials || "same-origin", !e.headers && this.headers || (this.headers = new h(e.headers)), this.method = (n = e.method || this.method || "GET", r = n.toUpperCase(), w.indexOf(r) > -1 ? r : n), this.mode = e.mode || this.mode || null, this.signal = e.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && i) throw new TypeError("Body not allowed for GET or HEAD requests");

        this._initBody(i);
      }

      function b(t) {
        var e = new FormData();
        return t.trim().split("&").forEach(function (t) {
          if (t) {
            var n = t.split("="),
                r = n.shift().replace(/\+/g, " "),
                i = n.join("=").replace(/\+/g, " ");
            e.append(decodeURIComponent(r), decodeURIComponent(i));
          }
        }), e;
      }

      function _(t, e) {
        e || (e = {}), this.type = "default", this.status = void 0 === e.status ? 200 : e.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in e ? e.statusText : "OK", this.headers = new h(e.headers), this.url = e.url || "", this._initBody(t);
      }

      v.prototype.clone = function () {
        return new v(this, {
          body: this._bodyInit
        });
      }, g.call(v.prototype), g.call(_.prototype), _.prototype.clone = function () {
        return new _(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new h(this.headers),
          url: this.url
        });
      }, _.error = function () {
        var t = new _(null, {
          status: 0,
          statusText: ""
        });
        return t.type = "error", t;
      };
      var A = [301, 302, 303, 307, 308];
      _.redirect = function (t, e) {
        if (-1 === A.indexOf(e)) throw new RangeError("Invalid status code");
        return new _(null, {
          status: e,
          headers: {
            location: t
          }
        });
      }, e.DOMException = t.DOMException;

      try {
        new e.DOMException();
      } catch (t) {
        e.DOMException = function (t, e) {
          this.message = t, this.name = e;
          var n = Error(t);
          this.stack = n.stack;
        }, e.DOMException.prototype = Object.create(Error.prototype), e.DOMException.prototype.constructor = e.DOMException;
      }

      function E(t, n) {
        return new Promise(function (r, o) {
          var s = new v(t, n);
          if (s.signal && s.signal.aborted) return o(new e.DOMException("Aborted", "AbortError"));
          var a = new XMLHttpRequest();

          function c() {
            a.abort();
          }

          a.onload = function () {
            var t,
                e,
                n = {
              status: a.status,
              statusText: a.statusText,
              headers: (t = a.getAllResponseHeaders() || "", e = new h(), t.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (t) {
                var n = t.split(":"),
                    r = n.shift().trim();

                if (r) {
                  var i = n.join(":").trim();
                  e.append(r, i);
                }
              }), e)
            };
            n.url = "responseURL" in a ? a.responseURL : n.headers.get("X-Request-URL");
            var i = "response" in a ? a.response : a.responseText;
            r(new _(i, n));
          }, a.onerror = function () {
            o(new TypeError("Network request failed"));
          }, a.ontimeout = function () {
            o(new TypeError("Network request failed"));
          }, a.onabort = function () {
            o(new e.DOMException("Aborted", "AbortError"));
          }, a.open(s.method, s.url, !0), "include" === s.credentials ? a.withCredentials = !0 : "omit" === s.credentials && (a.withCredentials = !1), "responseType" in a && i && (a.responseType = "blob"), s.headers.forEach(function (t, e) {
            a.setRequestHeader(e, t);
          }), s.signal && (s.signal.addEventListener("abort", c), a.onreadystatechange = function () {
            4 === a.readyState && s.signal.removeEventListener("abort", c);
          }), a.send(void 0 === s._bodyInit ? null : s._bodyInit);
        });
      }

      E.polyfill = !0, t.fetch || (t.fetch = E, t.Headers = h, t.Request = v, t.Response = _), e.Headers = h, e.Request = v, e.Response = _, e.fetch = E, Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }({});
  }(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
  var i = r;
  (e = i.fetch).default = i.fetch, e.fetch = i.fetch, e.Headers = i.Headers, e.Request = i.Request, e.Response = i.Response, t.exports = e;
}(ae, ae.exports);
var ce = Z(ae.exports);

function ue(_x31, _x32) {
  return _ue.apply(this, arguments);
}

function _ue() {
  _ue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(t, e) {
    var n, _le, r, i, _le2, o;

    return _regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) {
        switch (_context45.prev = _context45.next) {
          case 0:
            _context45.next = 2;
            return t.getAccountInfo(e);

          case 2:
            n = _context45.sent;

            if (!(null === n)) {
              _context45.next = 5;
              break;
            }

            throw new Error("program account not found");

          case 5:
            _le = le(n.data);
            r = _le.program;
            _context45.next = 9;
            return t.getAccountInfo(r.programdataAddress);

          case 9:
            i = _context45.sent;

            if (!(null === i)) {
              _context45.next = 12;
              break;
            }

            throw new Error("program data account not found");

          case 12:
            _le2 = le(i.data), o = _le2.programData;
            return _context45.abrupt("return", o);

          case 14:
          case "end":
            return _context45.stop();
        }
      }
    }, _callee45);
  }));
  return _ue.apply(this, arguments);
}

var de = h.rustEnum([h.struct([], "uninitialized"), h.struct([h.option(h.publicKey(), "authorityAddress")], "buffer"), h.struct([h.publicKey("programdataAddress")], "program"), h.struct([h.u64("slot"), h.option(h.publicKey(), "upgradeAuthorityAddress")], "programData")], void 0, h.u32());

function le(t) {
  return de.decode(t);
}

var he = Object.freeze({
  __proto__: null,
  verifiedBuild: function () {
    var _verifiedBuild = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(t, e) {
      var n,
          r,
          _yield$Promise$all,
          _yield$Promise$all2,
          i,
          o,
          s,
          a,
          _args10 = arguments;

      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              n = _args10.length > 2 && _args10[2] !== undefined ? _args10[2] : 5;
              r = "https://anchor.projectserum.com/api/v0/program/".concat(e.toString(), "/latest?limit=").concat(n);
              _context10.next = 4;
              return Promise.all([ue(t, e), ce(r)]);

            case 4:
              _yield$Promise$all = _context10.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              i = _yield$Promise$all2[0];
              o = _yield$Promise$all2[1];
              _context10.next = 10;
              return o.json();

            case 10:
              s = _context10.sent.filter(function (t) {
                return !t.aborted && "Built" === t.state && "Verified" === t.verified;
              });

              if (!(0 === s.length)) {
                _context10.next = 13;
                break;
              }

              return _context10.abrupt("return", null);

            case 13:
              a = s[0];
              return _context10.abrupt("return", i.slot.toNumber() !== a.verified_slot ? null : a);

            case 15:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    function verifiedBuild(_x33, _x34) {
      return _verifiedBuild.apply(this, arguments);
    }

    return verifiedBuild;
  }(),
  fetchData: ue,
  decodeUpgradeableLoaderState: le
}),
    pe = Object.freeze({
  __proto__: null,
  sha256: jt,
  rpc: Ft,
  publicKey: Zt,
  bytes: re,
  token: se,
  features: W,
  registry: he
});
var fe = h.struct([h.publicKey("authority"), h.vecU8("data")]);

function me(t, e) {
  var n, r;
  var i = {};
  var o = t.args ? t.args.length : 0;

  if (e.length > o) {
    if (e.length !== o + 1) throw new Error("provided too many arguments ".concat(e, " to instruction ").concat(null == t ? void 0 : t.name, " expecting: ").concat(null !== (r = null === (n = t.args) || void 0 === n ? void 0 : n.map(function (t) {
      return t.name;
    })) && void 0 !== r ? r : []));
    i = e.pop();
  }

  return [e, i];
}

var ye = /*#__PURE__*/function () {
  function ye() {
    _classCallCheck(this, ye);
  }

  _createClass(ye, null, [{
    key: "build",
    value: function build(t, e, n) {
      if ("_inner" === t.name) throw new A("the _inner name is reserved");

      var r = function r() {
        for (var _len4 = arguments.length, o = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          o[_key4] = arguments[_key4];
        }

        var _me = me(t, [].concat(o)),
            _me2 = _slicedToArray(_me, 2),
            s = _me2[0],
            a = _me2[1];

        Vt(t.accounts, a.accounts);
        var c = r.accounts(a.accounts);
        return void 0 !== a.remainingAccounts && c.push.apply(c, _toConsumableArray(a.remainingAccounts)), F("debug-logs") && console.log("Outgoing account metas:", c), new i({
          keys: c,
          programId: n,
          data: e(t.name, $t.apply(void 0, [t].concat(_toConsumableArray(s))))
        });
      };

      return r.accounts = function (e) {
        return ye.accountsArray(e, t.accounts, t.name);
      }, r;
    }
  }, {
    key: "accountsArray",
    value: function accountsArray(t, e, n) {
      return t ? e.map(function (e) {
        if (void 0 !== ("accounts" in e ? e.accounts : void 0)) {
          var _r8 = t[e.name];
          return ye.accountsArray(_r8, e.accounts, n).flat();
        }

        {
          var _r9 = e;

          var _i3;

          try {
            _i3 = Rt(t[e.name]);
          } catch (t) {
            throw new Error("Wrong input type for account \"".concat(e.name, "\" in the instruction accounts object").concat(void 0 !== n ? ' for instruction "' + n + '"' : "", ". Expected PublicKey or string."));
          }

          return {
            pubkey: _i3,
            isWritable: _r9.isMut,
            isSigner: _r9.isSigner
          };
        }
      }).flat() : [];
    }
  }]);

  return ye;
}();

var ge = /*#__PURE__*/function () {
  function ge() {
    _classCallCheck(this, ge);
  }

  _createClass(ge, null, [{
    key: "build",
    value: function build(t, e, n, r) {
      return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _len5,
            i,
            _key5,
            o,
            _me3,
            _me4,
            s,
            _e6,
            _args11 = arguments;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                for (_len5 = _args11.length, i = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                  i[_key5] = _args11[_key5];
                }

                o = e.apply(void 0, i), _me3 = me(t, [].concat(i)), _me4 = _slicedToArray(_me3, 2), s = _me4[1];
                _context11.prev = 2;
                _context11.next = 5;
                return r.send(o, s.signers, s.options);

              case 5:
                return _context11.abrupt("return", _context11.sent);

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11["catch"](2);
                F("debug-logs") && console.log("Translating error:", _context11.t0);
                _e6 = E.parse(_context11.t0, n);

                if (!(null === _e6)) {
                  _context11.next = 14;
                  break;
                }

                throw _context11.t0;

              case 14:
                throw _e6;

              case 15:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[2, 8]]);
      }));
    }
  }]);

  return ge;
}();

var we = /*#__PURE__*/function () {
  function we() {
    _classCallCheck(this, we);
  }

  _createClass(we, null, [{
    key: "build",
    value: function build(t, e) {
      return function () {
        var i, o, s;

        for (var _len6 = arguments.length, n = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          n[_key6] = arguments[_key6];
        }

        var _me5 = me(t, [].concat(n)),
            _me6 = _slicedToArray(_me5, 2),
            a = _me6[1],
            c = new r();

        if (a.preInstructions && a.instructions) throw new Error("instructions is deprecated, use preInstructions");
        return null === (i = a.preInstructions) || void 0 === i || i.forEach(function (t) {
          return c.add(t);
        }), null === (o = a.instructions) || void 0 === o || o.forEach(function (t) {
          return c.add(t);
        }), c.add(e.apply(void 0, n)), null === (s = a.postInstructions) || void 0 === s || s.forEach(function (t) {
          return c.add(t);
        }), c;
      };
    }
  }]);

  return we;
}();

var ve = /*#__PURE__*/function () {
  function ve(t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : b();
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new H(t);

    _classCallCheck(this, ve);

    this.provider = n, this.coder = r, this._idl = t, this._programId = e, this._address = be(e), this._sub = null;

    var _ref19 = function () {
      var i;
      var s = {},
          a = {},
          c = {};
      return null === (i = t.state) || void 0 === i || i.methods.forEach(function (i) {
        var u = ye.build(i, function (t, e) {
          return r.instruction.encodeState(t, e);
        }, e);

        u.accounts = function (t) {
          var r = function (t, e, n, r) {
            if ("new" === n.name) {
              var _Gt = Gt([], t),
                  _Gt2 = _slicedToArray(_Gt, 1),
                  _n8 = _Gt2[0];

              return [{
                pubkey: e.wallet.publicKey,
                isWritable: !1,
                isSigner: !0
              }, {
                pubkey: be(t),
                isWritable: !0,
                isSigner: !1
              }, {
                pubkey: _n8,
                isWritable: !1,
                isSigner: !1
              }, {
                pubkey: o.programId,
                isWritable: !1,
                isSigner: !1
              }, {
                pubkey: t,
                isWritable: !1,
                isSigner: !1
              }];
            }

            return Vt(n.accounts, r), [{
              pubkey: be(t),
              isWritable: !0,
              isSigner: !1
            }];
          }(e, n, i, t);

          return r.concat(ye.accountsArray(t, i.accounts, i.name));
        };

        var l = we.build(i, u),
            h = ge.build(i, l, Ct(t), n),
            p = d(i.name);
        s[p] = u, a[p] = l, c[p] = h;
      }), [s, a, c];
    }(),
        _ref20 = _slicedToArray(_ref19, 3),
        i = _ref20[0],
        s = _ref20[1],
        a = _ref20[2];

    this.instruction = i, this.transaction = s, this.rpc = a;
  }

  _createClass(ve, [{
    key: "programId",
    get: function get() {
      return this._programId;
    }
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var t, e, n;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                t = this.address();
                _context12.next = 3;
                return this.provider.connection.getAccountInfo(t);

              case 3:
                e = _context12.sent;

                if (!(null === e)) {
                  _context12.next = 6;
                  break;
                }

                throw new Error("Account does not exist ".concat(t.toString()));

              case 6:
                n = this._idl.state;

                if (n) {
                  _context12.next = 9;
                  break;
                }

                throw new Error("State is not specified in IDL.");

              case 9:
                _context12.next = 11;
                return G(n.struct.name);

              case 11:
                if (!_context12.sent.compare(e.data.slice(0, 8))) {
                  _context12.next = 13;
                  break;
                }

                throw new Error("Invalid account discriminator");

              case 13:
                return _context12.abrupt("return", this.coder.state.decode(e.data));

              case 14:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function fetch() {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: "address",
    value: function address() {
      return this._address;
    }
  }, {
    key: "subscribe",
    value: function subscribe(t) {
      var _this16 = this;

      if (null !== this._sub) return this._sub.ee;
      var e = new g(),
          n = this.provider.connection.onAccountChange(this.address(), function (t) {
        var n = _this16.coder.state.decode(t.data);

        e.emit("change", n);
      }, t);
      return this._sub = {
        ee: e,
        listener: n
      }, e;
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      var _this17 = this;

      null !== this._sub && this.provider.connection.removeAccountChangeListener(this._sub.listener).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this17._sub = null;

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))).catch(console.error);
    }
  }]);

  return ve;
}();

function be(t) {
  var _Gt3 = Gt([], t),
      _Gt4 = _slicedToArray(_Gt3, 1),
      e = _Gt4[0];

  return Wt(e, "unversioned", t);
}

var _e = /*#__PURE__*/function () {
  function _e(t, e, n, r, i) {
    _classCallCheck(this, _e);

    this._idlAccount = e, this._programId = n, this._provider = null != r ? r : b(), this._coder = null != i ? i : new H(t), this._size = this._coder.accounts.size(e);
  }

  _createClass(_e, [{
    key: "size",
    get: function get() {
      return this._size;
    }
  }, {
    key: "programId",
    get: function get() {
      return this._programId;
    }
  }, {
    key: "provider",
    get: function get() {
      return this._provider;
    }
  }, {
    key: "coder",
    get: function get() {
      return this._coder;
    }
  }, {
    key: "fetchNullable",
    value: function () {
      var _fetchNullable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(t, e) {
        var n;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.getAccountInfo(t, e);

              case 2:
                n = _context14.sent;
                return _context14.abrupt("return", null === n ? null : this._coder.accounts.decode(this._idlAccount.name, n.data));

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function fetchNullable(_x35, _x36) {
        return _fetchNullable.apply(this, arguments);
      }

      return fetchNullable;
    }()
  }, {
    key: "fetch",
    value: function () {
      var _fetch2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(t, e) {
        var n;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.fetchNullable(t, e);

              case 2:
                n = _context15.sent;

                if (!(null === n)) {
                  _context15.next = 5;
                  break;
                }

                throw new Error("Account does not exist ".concat(t.toString()));

              case 5:
                return _context15.abrupt("return", n);

              case 6:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function fetch(_x37, _x38) {
        return _fetch2.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: "fetchMultiple",
    value: function () {
      var _fetchMultiple = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(t, e) {
        var _this18 = this;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return Kt(this._provider.connection, t.map(function (t) {
                  return Rt(t);
                }), e);

              case 2:
                return _context16.abrupt("return", _context16.sent.map(function (t) {
                  return null == t ? null : _this18._coder.accounts.decode(_this18._idlAccount.name, null == t ? void 0 : t.account.data);
                }));

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function fetchMultiple(_x39, _x40) {
        return _fetchMultiple.apply(this, arguments);
      }

      return fetchMultiple;
    }()
  }, {
    key: "all",
    value: function () {
      var _all = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(t) {
        var _this19 = this;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this._provider.connection.getProgramAccounts(this._programId, {
                  commitment: this._provider.connection.commitment,
                  filters: [{
                    memcmp: this.coder.accounts.memcmp(this._idlAccount.name, t instanceof Buffer ? t : void 0)
                  }].concat(_toConsumableArray(Array.isArray(t) ? t : []))
                });

              case 2:
                return _context17.abrupt("return", _context17.sent.map(function (_ref22) {
                  var t = _ref22.pubkey,
                      e = _ref22.account;
                  return {
                    publicKey: t,
                    account: _this19._coder.accounts.decode(_this19._idlAccount.name, e.data)
                  };
                }));

              case 3:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function all(_x41) {
        return _all.apply(this, arguments);
      }

      return all;
    }()
  }, {
    key: "subscribe",
    value: function subscribe(t, e) {
      var _this20 = this;

      var n = Ae.get(t.toString());
      if (n) return n.ee;
      var r = new g();
      t = Rt(t);

      var i = this._provider.connection.onAccountChange(t, function (t) {
        var e = _this20._coder.accounts.decode(_this20._idlAccount.name, t.data);

        r.emit("change", e);
      }, e);

      return Ae.set(t.toString(), {
        ee: r,
        listener: i
      }), r;
    }
  }, {
    key: "unsubscribe",
    value: function () {
      var _unsubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                e = Ae.get(t.toString());

                if (!e) {
                  _context18.next = 8;
                  break;
                }

                _context18.t0 = Ae;

                if (!_context18.t0) {
                  _context18.next = 6;
                  break;
                }

                _context18.next = 6;
                return this._provider.connection.removeAccountChangeListener(e.listener).then(function () {
                  Ae.delete(t.toString());
                }).catch(console.error);

              case 6:
                _context18.next = 9;
                break;

              case 8:
                console.warn("Address is not subscribed");

              case 9:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function unsubscribe(_x42) {
        return _unsubscribe.apply(this, arguments);
      }

      return unsubscribe;
    }()
  }, {
    key: "createInstruction",
    value: function () {
      var _createInstruction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(t, e) {
        var n;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                n = this.size;
                _context19.t0 = o;
                _context19.t1 = this._provider.wallet.publicKey;
                _context19.t2 = t.publicKey;
                _context19.t3 = null != e ? e : n;
                _context19.next = 7;
                return this._provider.connection.getMinimumBalanceForRentExemption(null != e ? e : n);

              case 7:
                _context19.t4 = _context19.sent;
                _context19.t5 = this._programId;
                _context19.t6 = {
                  fromPubkey: _context19.t1,
                  newAccountPubkey: _context19.t2,
                  space: _context19.t3,
                  lamports: _context19.t4,
                  programId: _context19.t5
                };
                return _context19.abrupt("return", _context19.t0.createAccount.call(_context19.t0, _context19.t6));

              case 11:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function createInstruction(_x43, _x44) {
        return _createInstruction.apply(this, arguments);
      }

      return createInstruction;
    }()
  }, {
    key: "associated",
    value: function () {
      var _associated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var e,
            _args20 = arguments;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this.associatedAddress.apply(this, _args20);

              case 2:
                e = _context20.sent;
                _context20.next = 5;
                return this.fetch(e);

              case 5:
                return _context20.abrupt("return", _context20.sent);

              case 6:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function associated() {
        return _associated.apply(this, arguments);
      }

      return associated;
    }()
  }, {
    key: "associatedAddress",
    value: function () {
      var _associatedAddress2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var _len7,
            t,
            _key7,
            _args21 = arguments;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                for (_len7 = _args21.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                  t[_key7] = _args21[_key7];
                }

                _context21.next = 3;
                return Jt.apply(void 0, [this._programId].concat(t));

              case 3:
                return _context21.abrupt("return", _context21.sent);

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function associatedAddress() {
        return _associatedAddress2.apply(this, arguments);
      }

      return associatedAddress;
    }()
  }, {
    key: "getAccountInfo",
    value: function () {
      var _getAccountInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(t, e) {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this._provider.connection.getAccountInfo(Rt(t), e);

              case 2:
                return _context22.abrupt("return", _context22.sent);

              case 3:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function getAccountInfo(_x45, _x46) {
        return _getAccountInfo.apply(this, arguments);
      }

      return getAccountInfo;
    }()
  }]);

  return _e;
}();

var Ae = new Map(),
    Ee = "Program log: ".length;

var Ie = /*#__PURE__*/function () {
  function Ie(t, e, n) {
    _classCallCheck(this, Ie);

    this._programId = t, this._provider = e, this._eventParser = new Se(t, n), this._eventCallbacks = new Map(), this._eventListeners = new Map(), this._listenerIdCount = 0;
  }

  _createClass(Ie, [{
    key: "addEventListener",
    value: function addEventListener(t, e) {
      var _this21 = this;

      var n;
      var r = this._listenerIdCount;
      return this._listenerIdCount += 1, t in this._eventCallbacks || this._eventListeners.set(t, []), this._eventListeners.set(t, (null !== (n = this._eventListeners.get(t)) && void 0 !== n ? n : []).concat(r)), this._eventCallbacks.set(r, [t, e]), void 0 !== this._onLogsSubscriptionId || (this._onLogsSubscriptionId = this._provider.connection.onLogs(this._programId, function (t, e) {
        t.err || _this21._eventParser.parseLogs(t.logs, function (t) {
          var n = _this21._eventListeners.get(t.name);

          n && n.forEach(function (n) {
            var r = _this21._eventCallbacks.get(n);

            if (r) {
              var _r10 = _slicedToArray(r, 2),
                  _n9 = _r10[1];

              _n9(t.data, e.slot);
            }
          });
        });
      })), r;
    }
  }, {
    key: "removeEventListener",
    value: function () {
      var _removeEventListener = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(t) {
        var e, _e7, n, r;

        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                e = this._eventCallbacks.get(t);

                if (e) {
                  _context23.next = 3;
                  break;
                }

                throw new Error("Event listener ".concat(t, " doesn't exist!"));

              case 3:
                _e7 = _slicedToArray(e, 1), n = _e7[0];
                r = this._eventListeners.get(n);

                if (r) {
                  _context23.next = 7;
                  break;
                }

                throw new Error("Event listeners don't exist for ".concat(n, "!"));

              case 7:
                this._eventCallbacks.delete(t);

                r = r.filter(function (e) {
                  return e !== t;
                });
                0 === r.length && this._eventListeners.delete(n);
                _context23.t0 = 0 == this._eventCallbacks.size;

                if (!_context23.t0) {
                  _context23.next = 18;
                  break;
                }

                f.ok(0 === this._eventListeners.size);
                _context23.t1 = void 0 !== this._onLogsSubscriptionId;

                if (!_context23.t1) {
                  _context23.next = 18;
                  break;
                }

                _context23.next = 17;
                return this._provider.connection.removeOnLogsListener(this._onLogsSubscriptionId);

              case 17:
                this._onLogsSubscriptionId = void 0;

              case 18:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function removeEventListener(_x47) {
        return _removeEventListener.apply(this, arguments);
      }

      return removeEventListener;
    }()
  }]);

  return Ie;
}();

var Se = /*#__PURE__*/function () {
  function Se(t, e) {
    _classCallCheck(this, Se);

    this.coder = e, this.programId = t;
  }

  _createClass(Se, [{
    key: "parseLogs",
    value: function parseLogs(t, e) {
      var n = new ke(t),
          r = new xe(n.next());
      var i = n.next();

      for (; null !== i;) {
        var _this$handleLog = this.handleLog(r, i),
            _this$handleLog2 = _slicedToArray(_this$handleLog, 3),
            _t5 = _this$handleLog2[0],
            _o = _this$handleLog2[1],
            _s4 = _this$handleLog2[2];

        _t5 && e(_t5), _o && r.push(_o), _s4 && r.pop(), i = n.next();
      }
    }
  }, {
    key: "handleLog",
    value: function handleLog(t, e) {
      return t.stack.length > 0 && t.program() === this.programId.toString() ? this.handleProgramLog(e) : [null].concat(_toConsumableArray(this.handleSystemLog(e)));
    }
  }, {
    key: "handleProgramLog",
    value: function handleProgramLog(t) {
      if (t.startsWith("Program log:")) {
        var _e8 = t.slice(Ee);

        return [this.coder.events.decode(_e8), null, !1];
      }

      return [null].concat(_toConsumableArray(this.handleSystemLog(t)));
    }
  }, {
    key: "handleSystemLog",
    value: function handleSystemLog(t) {
      var e = t.split(":")[0];
      return null !== e.match(/^Program (.*) success/g) ? [null, !0] : e.startsWith("Program ".concat(this.programId.toString(), " invoke")) ? [this.programId.toString(), !1] : e.includes("invoke") ? ["cpi", !1] : [null, !1];
    }
  }]);

  return Se;
}();

var xe = /*#__PURE__*/function () {
  function xe(t) {
    _classCallCheck(this, xe);

    var e;
    var n = null === (e = /^Program (.*) invoke.*$/g.exec(t)) || void 0 === e ? void 0 : e[1];
    if (!n) throw new Error("Could not find program invocation log line");
    this.stack = [n];
  }

  _createClass(xe, [{
    key: "program",
    value: function program() {
      return f.ok(this.stack.length > 0), this.stack[this.stack.length - 1];
    }
  }, {
    key: "push",
    value: function push(t) {
      this.stack.push(t);
    }
  }, {
    key: "pop",
    value: function pop() {
      f.ok(this.stack.length > 0), this.stack.pop();
    }
  }]);

  return xe;
}();

var ke = /*#__PURE__*/function () {
  function ke(t) {
    _classCallCheck(this, ke);

    this.logs = t;
  }

  _createClass(ke, [{
    key: "next",
    value: function next() {
      if (0 === this.logs.length) return null;
      var t = this.logs[0];
      return this.logs = this.logs.slice(1), t;
    }
  }]);

  return ke;
}();

var Me = new n("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");

function Le() {
  return new Ut(Te);
}

var Te = {
  version: "0.1.0",
  name: "spl_token",
  instructions: [{
    name: "initializeMint",
    accounts: [{
      name: "mint",
      isMut: !0,
      isSigner: !1
    }, {
      name: "rent",
      isMut: !1,
      isSigner: !1
    }],
    args: [{
      name: "decimals",
      type: "u8"
    }, {
      name: "mintAuthority",
      type: "publicKey"
    }, {
      name: "freezeAuthority",
      type: {
        coption: "publicKey"
      }
    }]
  }, {
    name: "initializeAccount",
    accounts: [{
      name: "account",
      isMut: !0,
      isSigner: !1
    }, {
      name: "mint",
      isMut: !1,
      isSigner: !1
    }, {
      name: "authority",
      isMut: !1,
      isSigner: !1
    }, {
      name: "rent",
      isMut: !1,
      isSigner: !1
    }],
    args: []
  }, {
    name: "initializeMultisig",
    accounts: [{
      name: "account",
      isMut: !0,
      isSigner: !1
    }, {
      name: "rent",
      isMut: !1,
      isSigner: !1
    }],
    args: [{
      name: "m",
      type: "u8"
    }]
  }, {
    name: "transfer",
    accounts: [{
      name: "source",
      isMut: !0,
      isSigner: !1
    }, {
      name: "destination",
      isMut: !0,
      isSigner: !1
    }, {
      name: "authority",
      isMut: !1,
      isSigner: !0
    }],
    args: [{
      name: "amount",
      type: "u64"
    }]
  }, {
    name: "approve",
    accounts: [{
      name: "source",
      isMut: !0,
      isSigner: !1
    }, {
      name: "delegate",
      isMut: !1,
      isSigner: !1
    }, {
      name: "authority",
      isMut: !1,
      isSigner: !0
    }],
    args: [{
      name: "amount",
      type: "u64"
    }]
  }, {
    name: "revoke",
    accounts: [{
      name: "source",
      isMut: !0,
      isSigner: !1
    }, {
      name: "authority",
      isMut: !1,
      isSigner: !0
    }],
    args: []
  }, {
    name: "setAuthority",
    accounts: [{
      name: "mint",
      isMut: !0,
      isSigner: !1
    }, {
      name: "authority",
      isMut: !1,
      isSigner: !0
    }],
    args: [{
      name: "authorityType",
      type: "u8"
    }, {
      name: "newAuthority",
      type: {
        coption: "publicKey"
      }
    }]
  }, {
    name: "mintTo",
    accounts: [{
      name: "mint",
      isMut: !0,
      isSigner: !1
    }, {
      name: "to",
      isMut: !0,
      isSigner: !1
    }, {
      name: "authority",
      isMut: !1,
      isSigner: !0
    }],
    args: [{
      name: "amount",
      type: "u64"
    }]
  }, {
    name: "burn",
    accounts: [{
      name: "source",
      isMut: !0,
      isSigner: !1
    }, {
      name: "mint",
      isMut: !0,
      isSigner: !1
    }, {
      name: "authority",
      isMut: !1,
      isSigner: !0
    }],
    args: [{
      name: "amount",
      type: "u64"
    }]
  }, {
    name: "closeAccount",
    accounts: [{
      name: "account",
      isMut: !0,
      isSigner: !1
    }, {
      name: "destination",
      isMut: !0,
      isSigner: !1
    }, {
      name: "authority",
      isMut: !1,
      isSigner: !1
    }],
    args: []
  }, {
    name: "freezeAccount",
    accounts: [{
      name: "account",
      isMut: !0,
      isSigner: !1
    }, {
      name: "mint",
      isMut: !1,
      isSigner: !1
    }, {
      name: "authority",
      isMut: !1,
      isSigner: !0
    }],
    args: []
  }, {
    name: "thawAccount",
    accounts: [{
      name: "account",
      isMut: !0,
      isSigner: !1
    }, {
      name: "mint",
      isMut: !1,
      isSigner: !1
    }, {
      name: "authority",
      isMut: !1,
      isSigner: !0
    }],
    args: []
  }, {
    name: "transferChecked",
    accounts: [{
      name: "source",
      isMut: !0,
      isSigner: !1
    }, {
      name: "mint",
      isMut: !1,
      isSigner: !1
    }, {
      name: "destination",
      isMut: !0,
      isSigner: !1
    }, {
      name: "authority",
      isMut: !1,
      isSigner: !0
    }],
    args: [{
      name: "amount",
      type: "u64"
    }, {
      name: "decimals",
      type: "u8"
    }]
  }, {
    name: "approveChecked",
    accounts: [{
      name: "source",
      isMut: !0,
      isSigner: !1
    }, {
      name: "mint",
      isMut: !1,
      isSigner: !1
    }, {
      name: "delegate",
      isMut: !1,
      isSigner: !1
    }, {
      name: "authority",
      isMut: !1,
      isSigner: !0
    }],
    args: [{
      name: "amount",
      type: "u64"
    }, {
      name: "decimals",
      type: "u8"
    }]
  }, {
    name: "mintToChecked",
    accounts: [{
      name: "mint",
      isMut: !0,
      isSigner: !1
    }, {
      name: "to",
      isMut: !0,
      isSigner: !1
    }, {
      name: "authority",
      isMut: !1,
      isSigner: !0
    }],
    args: [{
      name: "amount",
      type: "u64"
    }, {
      name: "decimals",
      type: "u8"
    }]
  }, {
    name: "burnChecked",
    accounts: [{
      name: "source",
      isMut: !0,
      isSigner: !1
    }, {
      name: "mint",
      isMut: !0,
      isSigner: !1
    }, {
      name: "authority",
      isMut: !1,
      isSigner: !0
    }],
    args: [{
      name: "amount",
      type: "u64"
    }, {
      name: "decimals",
      type: "u8"
    }]
  }, {
    name: "initializeAccount2",
    accounts: [{
      name: "account",
      isMut: !0,
      isSigner: !1
    }, {
      name: "mint",
      isMut: !1,
      isSigner: !1
    }, {
      name: "rent",
      isMut: !1,
      isSigner: !1
    }],
    args: [{
      name: "authority",
      type: "publicKey"
    }]
  }, {
    name: "syncNative",
    accounts: [{
      name: "account",
      isMut: !0,
      isSigner: !1
    }],
    args: []
  }, {
    name: "initializeAccount3",
    accounts: [{
      name: "account",
      isMut: !0,
      isSigner: !1
    }, {
      name: "mint",
      isMut: !1,
      isSigner: !1
    }],
    args: [{
      name: "authority",
      type: "publicKey"
    }]
  }, {
    name: "initializeMultisig2",
    accounts: [{
      name: "account",
      isMut: !0,
      isSigner: !1
    }],
    args: [{
      name: "m",
      type: "u8"
    }]
  }, {
    name: "initializeMint2",
    accounts: [{
      name: "mint",
      isMut: !0,
      isSigner: !1
    }],
    args: [{
      name: "decimals",
      type: "u8"
    }, {
      name: "mintAuthority",
      type: "publicKey"
    }, {
      name: "freezeAuthority",
      type: {
        coption: "publicKey"
      }
    }]
  }],
  accounts: [{
    name: "Mint",
    type: {
      kind: "struct",
      fields: [{
        name: "mintAuthority",
        type: {
          coption: "publicKey"
        }
      }, {
        name: "supply",
        type: "u64"
      }, {
        name: "decimals",
        type: "u8"
      }, {
        name: "isInitialized",
        type: "bool"
      }, {
        name: "freezeAuthority",
        type: {
          coption: "publicKey"
        }
      }]
    }
  }, {
    name: "Token",
    type: {
      kind: "struct",
      fields: [{
        name: "mint",
        type: "publicKey"
      }, {
        name: "authority",
        type: "publicKey"
      }, {
        name: "amount",
        type: "u64"
      }, {
        name: "delegate",
        type: {
          coption: "publicKey"
        }
      }, {
        name: "state",
        type: "u8"
      }, {
        name: "isNative",
        type: {
          coption: "u64"
        }
      }, {
        name: "delegatedAmount",
        type: "u64"
      }, {
        name: "closeAuthority",
        type: {
          coption: "publicKey"
        }
      }]
    }
  }]
};

var Be = /*#__PURE__*/function () {
  function Be(t, e, n, r, i, o) {
    _classCallCheck(this, Be);

    this._args = t, this._accounts = e, this._provider = n, this._programId = r, this._idlIx = i, this._accountStore = new Pe(n, o);
  }

  _createClass(Be, [{
    key: "resolve",
    value: function () {
      var _resolve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        var _t6, _e9, _n10;

        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _t6 = 0;

              case 1:
                if (!(_t6 < this._idlIx.accounts.length)) {
                  _context24.next = 12;
                  break;
                }

                _e9 = this._idlIx.accounts[_t6], _n10 = d(_e9.name);

                if (!(_e9.pda && _e9.pda.seeds.length > 0 && void 0 === this._accounts[_n10])) {
                  _context24.next = 8;
                  break;
                }

                _context24.next = 6;
                return this.autoPopulatePda(_e9);

              case 6:
                _context24.next = 9;
                break;

              case 8:
                if (_e9.isSigner && void 0 === this._accounts[_n10]) this._accounts[_n10] = this._provider.wallet.publicKey;else switch (_n10) {
                  case "systemProgram":
                    void 0 === this._accounts[_n10] && (this._accounts[_n10] = o.programId);

                  case "rent":
                    void 0 === this._accounts[_n10] && (this._accounts[_n10] = s);

                  case "tokenProgram":
                    void 0 === this._accounts[_n10] && (this._accounts[_n10] = ie);

                  case "associatedTokenProgram":
                    void 0 === this._accounts[_n10] && (this._accounts[_n10] = oe);
                }

              case 9:
                _t6 += 1;
                _context24.next = 1;
                break;

              case 12:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function resolve() {
        return _resolve.apply(this, arguments);
      }

      return resolve;
    }()
  }, {
    key: "autoPopulatePda",
    value: function () {
      var _autoPopulatePda = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(t) {
        var _this22 = this;

        var e, r, _yield$n$findProgramA, _yield$n$findProgramA2, i;

        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (!(!t.pda || !t.pda.seeds)) {
                  _context25.next = 2;
                  break;
                }

                throw new Error("Must have seeds");

              case 2:
                _context25.next = 4;
                return Promise.all(t.pda.seeds.map(function (t) {
                  return _this22.toBuffer(t);
                }));

              case 4:
                e = _context25.sent;
                _context25.next = 7;
                return this.parseProgramId(t);

              case 7:
                r = _context25.sent;
                _context25.next = 10;
                return n.findProgramAddress(e, r);

              case 10:
                _yield$n$findProgramA = _context25.sent;
                _yield$n$findProgramA2 = _slicedToArray(_yield$n$findProgramA, 1);
                i = _yield$n$findProgramA2[0];
                this._accounts[d(t.name)] = i;

              case 14:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function autoPopulatePda(_x48) {
        return _autoPopulatePda.apply(this, arguments);
      }

      return autoPopulatePda;
    }()
  }, {
    key: "parseProgramId",
    value: function () {
      var _parseProgramId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                if (null === (e = t.pda) || void 0 === e ? void 0 : e.programId) {
                  _context26.next = 2;
                  break;
                }

                return _context26.abrupt("return", this._programId);

              case 2:
                _context26.t0 = t.pda.programId.kind;
                _context26.next = _context26.t0 === "const" ? 5 : _context26.t0 === "arg" ? 6 : _context26.t0 === "account" ? 7 : 10;
                break;

              case 5:
                return _context26.abrupt("return", new n(this.toBufferConst(t.pda.programId.value)));

              case 6:
                return _context26.abrupt("return", this.argValue(t.pda.programId));

              case 7:
                _context26.next = 9;
                return this.accountValue(t.pda.programId);

              case 9:
                return _context26.abrupt("return", _context26.sent);

              case 10:
                throw new Error("Unexpected program seed kind: ".concat(t.pda.programId.kind));

              case 11:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function parseProgramId(_x49) {
        return _parseProgramId.apply(this, arguments);
      }

      return parseProgramId;
    }()
  }, {
    key: "toBuffer",
    value: function () {
      var _toBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(t) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.t0 = t.kind;
                _context27.next = _context27.t0 === "const" ? 3 : _context27.t0 === "arg" ? 4 : _context27.t0 === "account" ? 7 : 10;
                break;

              case 3:
                return _context27.abrupt("return", this.toBufferConst(t));

              case 4:
                _context27.next = 6;
                return this.toBufferArg(t);

              case 6:
                return _context27.abrupt("return", _context27.sent);

              case 7:
                _context27.next = 9;
                return this.toBufferAccount(t);

              case 9:
                return _context27.abrupt("return", _context27.sent);

              case 10:
                throw new Error("Unexpected seed kind: ".concat(t.kind));

              case 11:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function toBuffer(_x50) {
        return _toBuffer.apply(this, arguments);
      }

      return toBuffer;
    }()
  }, {
    key: "toBufferConst",
    value: function toBufferConst(t) {
      return this.toBufferValue(t.type, t.value);
    }
  }, {
    key: "toBufferArg",
    value: function () {
      var _toBufferArg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                e = this.argValue(t);
                return _context28.abrupt("return", this.toBufferValue(t.type, e));

              case 2:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function toBufferArg(_x51) {
        return _toBufferArg.apply(this, arguments);
      }

      return toBufferArg;
    }()
  }, {
    key: "argValue",
    value: function argValue(t) {
      var e = d(t.path.split(".")[0]),
          n = this._idlIx.args.findIndex(function (t) {
        return t.name === e;
      });

      if (-1 === n) throw new Error("Unable to find argument for seed: ".concat(e));
      return this._args[n];
    }
  }, {
    key: "toBufferAccount",
    value: function () {
      var _toBufferAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return this.accountValue(t);

              case 2:
                e = _context29.sent;
                return _context29.abrupt("return", this.toBufferValue(t.type, e));

              case 4:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function toBufferAccount(_x52) {
        return _toBufferAccount.apply(this, arguments);
      }

      return toBufferAccount;
    }()
  }, {
    key: "accountValue",
    value: function () {
      var _accountValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(t) {
        var e, n, r, i;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                e = t.path.split("."), n = e[0], r = this._accounts[d(n)];

                if (!(1 === e.length)) {
                  _context30.next = 3;
                  break;
                }

                return _context30.abrupt("return", r);

              case 3:
                _context30.next = 5;
                return this._accountStore.fetchAccount(t.account, r);

              case 5:
                i = _context30.sent;
                return _context30.abrupt("return", this.parseAccountValue(i, e.slice(1)));

              case 7:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function accountValue(_x53) {
        return _accountValue.apply(this, arguments);
      }

      return accountValue;
    }()
  }, {
    key: "parseAccountValue",
    value: function parseAccountValue(t, e) {
      var n;

      for (; e.length > 0;) {
        n = t[d(e[0])], e = e.slice(1);
      }

      return n;
    }
  }, {
    key: "toBufferValue",
    value: function toBufferValue(t, e) {
      switch (t) {
        case "u8":
          return Buffer.from([e]);

        case "u16":
          var _n11 = Buffer.alloc(2);

          return _n11.writeUInt16LE(e), _n11;

        case "u32":
          var _r11 = Buffer.alloc(4);

          return _r11.writeUInt32LE(e), _r11;

        case "u64":
          var _i4 = Buffer.alloc(8);

          return _i4.writeBigUInt64LE(BigInt(e)), _i4;

        case "string":
          return Buffer.from(Yt(e));

        case "publicKey":
          return e.toBuffer();

        default:
          if (t.array) return Buffer.from(e);
          throw new Error("Unexpected seed type: ".concat(t));
      }
    }
  }]);

  return Be;
}();

var Pe = /*#__PURE__*/function () {
  function Pe(t, e) {
    _classCallCheck(this, Pe);

    this._provider = t, this._accounts = e, this._cache = new Map();
  }

  _createClass(Pe, [{
    key: "fetchAccount",
    value: function () {
      var _fetchAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(t, e) {
        var n, _t7, _r12, _r13;

        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                n = e.toString();

                if (!(void 0 === this._cache.get(n))) {
                  _context31.next = 14;
                  break;
                }

                if (!("TokenAccount" === t)) {
                  _context31.next = 12;
                  break;
                }

                _context31.next = 5;
                return this._provider.connection.getAccountInfo(e);

              case 5:
                _t7 = _context31.sent;

                if (!(null === _t7)) {
                  _context31.next = 8;
                  break;
                }

                throw new Error("invalid account info for ".concat(n));

              case 8:
                _r12 = Le().accounts.decode("Token", _t7.data);

                this._cache.set(n, _r12);

                _context31.next = 14;
                break;

              case 12:
                _r13 = this._accounts[d(t)].fetch(e);

                this._cache.set(n, _r13);

              case 14:
                return _context31.abrupt("return", this._cache.get(n));

              case 15:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function fetchAccount(_x54, _x55) {
        return _fetchAccount.apply(this, arguments);
      }

      return fetchAccount;
    }()
  }]);

  return Pe;
}();

var Oe = /*#__PURE__*/function () {
  function Oe() {
    _classCallCheck(this, Oe);
  }

  _createClass(Oe, null, [{
    key: "build",
    value: function build(t, e, n, r, i, o, s, a) {
      return function () {
        for (var _len8 = arguments.length, c = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
          c[_key8] = arguments[_key8];
        }

        return new ze(c, r, i, o, s, t, e, n, a);
      };
    }
  }]);

  return Oe;
}();

var ze = /*#__PURE__*/function () {
  function ze(t, e, n, r, i, o, s, a, c) {
    _classCallCheck(this, ze);

    this._args = t, this._ixFn = e, this._txFn = n, this._rpcFn = r, this._simulateFn = i, this._accounts = {}, this._remainingAccounts = [], this._signers = [], this._preInstructions = [], this._postInstructions = [], this._accountsResolver = new Be(t, this._accounts, o, s, a, c);
  }

  _createClass(ze, [{
    key: "accounts",
    value: function accounts(t) {
      return Object.assign(this._accounts, t), this;
    }
  }, {
    key: "signers",
    value: function signers(t) {
      return this._signers = this._signers.concat(t), this;
    }
  }, {
    key: "remainingAccounts",
    value: function remainingAccounts(t) {
      return this._remainingAccounts = this._remainingAccounts.concat(t), this;
    }
  }, {
    key: "preInstructions",
    value: function preInstructions(t) {
      return this._preInstructions = this._preInstructions.concat(t), this;
    }
  }, {
    key: "postInstructions",
    value: function postInstructions(t) {
      return this._postInstructions = this._postInstructions.concat(t), this;
    }
  }, {
    key: "rpc",
    value: function () {
      var _rpc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(t) {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return this._accountsResolver.resolve();

              case 2:
                return _context32.abrupt("return", this._rpcFn.apply(this, _toConsumableArray(this._args).concat([{
                  accounts: this._accounts,
                  signers: this._signers,
                  remainingAccounts: this._remainingAccounts,
                  preInstructions: this._preInstructions,
                  postInstructions: this._postInstructions,
                  options: t
                }])));

              case 3:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function rpc(_x56) {
        return _rpc.apply(this, arguments);
      }

      return rpc;
    }()
  }, {
    key: "simulate",
    value: function () {
      var _simulate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(t) {
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return this._accountsResolver.resolve();

              case 2:
                return _context33.abrupt("return", this._simulateFn.apply(this, _toConsumableArray(this._args).concat([{
                  accounts: this._accounts,
                  signers: this._signers,
                  remainingAccounts: this._remainingAccounts,
                  preInstructions: this._preInstructions,
                  postInstructions: this._postInstructions,
                  options: t
                }])));

              case 3:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function simulate(_x57) {
        return _simulate2.apply(this, arguments);
      }

      return simulate;
    }()
  }, {
    key: "instruction",
    value: function () {
      var _instruction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.next = 2;
                return this._accountsResolver.resolve();

              case 2:
                return _context34.abrupt("return", this._ixFn.apply(this, _toConsumableArray(this._args).concat([{
                  accounts: this._accounts,
                  signers: this._signers,
                  remainingAccounts: this._remainingAccounts,
                  preInstructions: this._preInstructions,
                  postInstructions: this._postInstructions
                }])));

              case 3:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function instruction() {
        return _instruction.apply(this, arguments);
      }

      return instruction;
    }()
  }, {
    key: "transaction",
    value: function () {
      var _transaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.next = 2;
                return this._accountsResolver.resolve();

              case 2:
                return _context35.abrupt("return", this._txFn.apply(this, _toConsumableArray(this._args).concat([{
                  accounts: this._accounts,
                  signers: this._signers,
                  remainingAccounts: this._remainingAccounts,
                  preInstructions: this._preInstructions,
                  postInstructions: this._postInstructions
                }])));

              case 3:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function transaction() {
        return _transaction.apply(this, arguments);
      }

      return transaction;
    }()
  }]);

  return ze;
}();

var De = /*#__PURE__*/function () {
  function De(t, e, n, r) {
    _classCallCheck(this, De);

    e = Rt(e), n || (n = b()), this._idl = t, this._provider = n, this._programId = e, this._coder = null != r ? r : new H(t), this._events = new Ie(this._programId, n, this._coder);

    var _build = /*#__PURE__*/function () {
      function _class() {
        _classCallCheck(this, _class);
      }

      _createClass(_class, null, [{
        key: "build",
        value: function build(t, e, n, r) {
          var i = {},
              o = {},
              s = {},
              a = {},
              c = {},
              u = Ct(t),
              l = t.accounts ? /*#__PURE__*/function () {
            function _class2() {
              _classCallCheck(this, _class2);
            }

            _createClass(_class2, null, [{
              key: "build",
              value: function build(t, e, n, r) {
                var i;
                var o = {};
                return null === (i = t.accounts) || void 0 === i || i.forEach(function (i) {
                  var s = d(i.name);
                  o[s] = new _e(t, i, n, r, e);
                }), o;
              }
            }]);

            return _class2;
          }().build(t, e, n, r) : {},
              h = /*#__PURE__*/function () {
            function _class3() {
              _classCallCheck(this, _class3);
            }

            _createClass(_class3, null, [{
              key: "build",
              value: function build(t, e, n, r) {
                if (void 0 !== t.state) return new ve(t, n, r, e);
              }
            }]);

            return _class3;
          }().build(t, e, n, r);

          return t.instructions.forEach(function (h) {
            var p = ye.build(h, function (t, n) {
              return e.instruction.encode(t, n);
            }, n),
                f = we.build(h, p),
                m = ge.build(h, f, u, r),
                y = /*#__PURE__*/function () {
              function _class4() {
                _classCallCheck(this, _class4);
              }

              _createClass(_class4, null, [{
                key: "build",
                value: function build(t, e, n, r, i, o, s) {
                  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
                    var _len9,
                        a,
                        _key9,
                        c,
                        _me7,
                        _me8,
                        u,
                        d,
                        _e10,
                        l,
                        h,
                        _args36 = arguments;

                    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
                      while (1) {
                        switch (_context36.prev = _context36.next) {
                          case 0:
                            for (_len9 = _args36.length, a = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
                              a[_key9] = _args36[_key9];
                            }

                            c = e.apply(void 0, a), _me7 = me(t, [].concat(a)), _me8 = _slicedToArray(_me7, 2), u = _me8[1];
                            _context36.prev = 2;
                            _context36.next = 5;
                            return r.simulate(c, u.signers, u.options);

                          case 5:
                            d = _context36.sent;
                            _context36.next = 15;
                            break;

                          case 8:
                            _context36.prev = 8;
                            _context36.t0 = _context36["catch"](2);
                            F("debug-logs") && console.log("Translating error:", _context36.t0);
                            _e10 = E.parse(_context36.t0, n);

                            if (!(null === _e10)) {
                              _context36.next = 14;
                              break;
                            }

                            throw _context36.t0;

                          case 14:
                            throw _e10;

                          case 15:
                            if (!(void 0 === d)) {
                              _context36.next = 17;
                              break;
                            }

                            throw new Error("Unable to simulate transaction");

                          case 17:
                            if (!d.value.err) {
                              _context36.next = 19;
                              break;
                            }

                            throw new Error("Simulate error: ".concat(d.value.err.toString()));

                          case 19:
                            l = d.value.logs;

                            if (l) {
                              _context36.next = 22;
                              break;
                            }

                            throw new Error("Simulated logs not found");

                          case 22:
                            h = [];
                            return _context36.abrupt("return", (s.events && new Se(o, i).parseLogs(l, function (t) {
                              h.push(t);
                            }), {
                              events: h,
                              raw: l
                            }));

                          case 24:
                          case "end":
                            return _context36.stop();
                        }
                      }
                    }, _callee36, null, [[2, 8]]);
                  }));
                }
              }]);

              return _class4;
            }().build(h, f, u, r, e, n, t),
                g = Oe.build(r, n, h, p, f, m, y, l),
                w = d(h.name);

            o[w] = p, s[w] = f, i[w] = m, a[w] = y, c[w] = g;
          }), [i, o, s, l, a, c, h];
        }
      }]);

      return _class;
    }().build(t, this._coder, e, n),
        _build2 = _slicedToArray(_build, 7),
        i = _build2[0],
        o = _build2[1],
        s = _build2[2],
        a = _build2[3],
        c = _build2[4],
        u = _build2[5],
        l = _build2[6];

    this.rpc = i, this.instruction = o, this.transaction = s, this.account = a, this.simulate = c, this.methods = u, this.state = l;
  }

  _createClass(De, [{
    key: "programId",
    get: function get() {
      return this._programId;
    }
  }, {
    key: "idl",
    get: function get() {
      return this._idl;
    }
  }, {
    key: "coder",
    get: function get() {
      return this._coder;
    }
  }, {
    key: "provider",
    get: function get() {
      return this._provider;
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(t, e) {
      return this._events.addEventListener(t, e);
    }
  }, {
    key: "removeEventListener",
    value: function () {
      var _removeEventListener2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(t) {
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.next = 2;
                return this._events.removeEventListener(t);

              case 2:
                return _context37.abrupt("return", _context37.sent);

              case 3:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function removeEventListener(_x58) {
        return _removeEventListener2.apply(this, arguments);
      }

      return removeEventListener;
    }()
  }], [{
    key: "at",
    value: function () {
      var _at = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(t, e) {
        var n, r;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                n = Rt(t);
                _context38.next = 3;
                return De.fetchIdl(n, e);

              case 3:
                r = _context38.sent;

                if (r) {
                  _context38.next = 6;
                  break;
                }

                throw new Error("IDL not found for program: ".concat(t.toString()));

              case 6:
                return _context38.abrupt("return", new De(r, n, e));

              case 7:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38);
      }));

      function at(_x59, _x60) {
        return _at.apply(this, arguments);
      }

      return at;
    }()
  }, {
    key: "fetchIdl",
    value: function () {
      var _fetchIdl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(t, e) {
        var r, i, o, s, a, c;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                e = null != e ? e : b();
                r = Rt(t);
                _context40.next = 4;
                return function () {
                  var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(t) {
                    var e;
                    return _regeneratorRuntime.wrap(function _callee39$(_context39) {
                      while (1) {
                        switch (_context39.prev = _context39.next) {
                          case 0:
                            _context39.next = 2;
                            return n.findProgramAddress([], t);

                          case 2:
                            e = _context39.sent[0];
                            _context39.next = 5;
                            return n.createWithSeed(e, "anchor:idl", t);

                          case 5:
                            return _context39.abrupt("return", _context39.sent);

                          case 6:
                          case "end":
                            return _context39.stop();
                        }
                      }
                    }, _callee39);
                  }));

                  return function (_x63) {
                    return _ref24.apply(this, arguments);
                  };
                }()(r);

              case 4:
                i = _context40.sent;
                _context40.next = 7;
                return e.connection.getAccountInfo(i);

              case 7:
                o = _context40.sent;

                if (o) {
                  _context40.next = 10;
                  break;
                }

                return _context40.abrupt("return", null);

              case 10:
                s = (a = o.data.slice(8), fe.decode(a));
                c = y(s.data);
                return _context40.abrupt("return", JSON.parse(Xt(c)));

              case 13:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40);
      }));

      function fetchIdl(_x61, _x62) {
        return _fetchIdl.apply(this, arguments);
      }

      return fetchIdl;
    }()
  }]);

  return De;
}();

var Ue = /*#__PURE__*/function () {
  function Ue() {
    _classCallCheck(this, Ue);
  }

  _createClass(Ue, null, [{
    key: "token",
    value: function token() {
      return new De(Te, Me, t, Le());
      var t;
    }
  }]);

  return Ue;
}();

export { C as ACCOUNT_DISCRIMINATOR_SIZE, _e as AccountClient, $ as BorshAccountsCoder, H as BorshCoder, V as BorshEventCoder, O as BorshInstructionCoder, q as BorshStateCoder, Ie as EventManager, Se as EventParser, A as IdlError, Oe as MethodsBuilderFactory, De as Program, E as ProgramError, w as Provider, Ue as Spl, Ut as SplTokenCoder, ve as StateClient, R as eventDiscriminator, b as getProvider, Ct as parseIdlErrors, v as setProvider, me as splitArgsAndCtx, G as stateDiscriminator, $t as toInstruction, Rt as translateAddress, pe as utils, Vt as validateAccounts };